import common from './common'
import featuresPay from './feature'

const de = {
    featuresPay,
    common,
    SerialNumberDrawer: {
        productVariants: "Produkt/Varianten",
        serialNumber: "Seriennummer",
        noProductsFound: "Keine Produkte gefunden",
        searchByProductSku: "Suche nach Produkt/SKU",
        searchSerialNumbers: "Seriennummern suchen",
        transactionDetails: "Transaktionsdetails",
        notAvailable: "N/A",
        mainWarehouse: "Hauptlager"
    },
    new_build_banner: {
        title: 'Neue Version:',
        is_available: 'ist jetzt verfügbar',
        fallback_title: 'Eine neue Version der App ist verfügbar',
        desc: 'Aktualisieren Sie, um die neuesten Funktionen und Verbesserungen zu erhalten.',
        refreshing: 'Aktualisierung…',
        refresh_now: 'Jetzt aktualisieren',
        later: 'Später',
        you_are_on: "Sie verwenden"
    },
    short: {
        finance: 'Finanzen',
        stock: 'Lager'
    },
    onboarding: {
        welcome: 'Willkommen!',
        step: {
            product: {
                totalBreakdown: 'Gesamtaufschlüsselung',
                overallFulfilment: 'Gesamterfüllung',
                totalShippedQty: 'Gesendete Gesamtmenge',
                totalReceivedQty: 'Erhaltene Gesamtmenge',
                totalOrderedQty: 'Bestellte Gesamtmenge',
                totalShippedOrdered: 'Gesamt versandt / bestellt',
                totalReceivedOrdered: 'Gesamt erhalten / bestellt',
                viewQty: 'Menge anzeigen',
                fetchingQty: 'Mengenangaben werden abgerufen...',
                noStockInfo: 'Keine Bestandsinformationen gefunden',
                title: '65% Erreicht',
                description: 'Nur noch 2 Schritte, um Ihren großen Erfolg zu starten!',
                Warehouse: "Lager",
            },
            stock: {
                title: '95% Fast Fertig!!',
                description: 'Nur noch ein Schritt, um Ihren großen Erfolg zu starten! Beenden Sie es jetzt.'
            }
        },
        business: {
            title: 'Geschäft erfolgreich erstellt!',
            description: 'Großartig! Ihr Geschäft wurde registriert.'
        },
        product: {
            title: 'Fügen Sie Ihr erstes Produkt hinzu',
            description: 'Fügen Sie ein Produkt hinzu, um den Lagerbestand zu erfassen.',
            Warehouse: "Lager",
        },
        stock: {
            title: 'Versuchen Sie, Lager hinzuzufügen',
            description: 'Beginnen Sie mit der Erfassung von eingehendem und ausgehendem Lager.'
        },
        action: {
            add_business: {
                title: 'Geschäft erstellen',
                description: 'Möchten Sie ein neues Geschäft erstellen? Klicken Sie hier.'
            },
            join_business: {
                title: 'Geschäft beitreten',
                description: 'Haben Sie einen Einladungscode? Treten Sie hier bei.'
            }
        }
    },
    business: {
        title: 'Wählen Sie ein Unternehmen, erstellen Sie ein neues oder treten Sie bei',
        add_business: {
            title: 'Neues Unternehmen erstellen',
            name: 'Unternehmensname',
            name_placeholder: 'Namen eingeben',
            category: 'Unternehmenscategory',
            category_placeholder: 'Kategorie auswählen',
            button: 'Unternehmen erstellen'
        },
        edit_business: {
            title: 'Unternehmen bearbeiten'
        },
        join_business: {
            title: 'Unternehmen beitreten',
            input_code: 'Geben Sie den Einladungscode unten ein:',
            field_placeholder: 'Einladungscode',
            confirm_title: 'Beitreten',
            confirm_text: 'Sie werden Teil des Teams bei '
        },
        no_business: 'Kein Unternehmen verfügbar',
        create_or_join: 'Erstellen oder einem Unternehmen beitreten',
        message: {
            saved: 'Unternehmen erfolgreich gespeichert!'
        },
        settings: {
            isNegativeTransactionDisabled: 'Negative Bestandstransaktionen',
            isNegativeTransactionDisabledHint: 'Wenn diese Option aktiviert ist, werden Transaktionen verhindert, die zu negativem Bestand führen würden.',
            negativeStockError: 'Negative Bestandstransaktionen sind deaktiviert'
        }
    },
    profile: {
        edit_profile: {
            title: 'Profil bearbeiten',
            name: 'Vollständiger Name',
            name_placeholder: 'Vollständigen Namen eingeben',
            email: 'E-Mail',
            phone_number: 'Telefonnummer'
        },
        message: {
            required_name: 'Name ist erforderlich'
        }
    },
    product: {
        weightedAverageCost: 'Gewichtete Durchschnittskosten',
        weightedAverageValueLabel: 'Gewichteter Durchschnittswert',
        Product: 'Produkt',
        hideZeroStock: 'Nullbestand ausblenden',
        allVariants: 'Alle Varianten',
        choose_product: 'Produkt wählen',
        choose_product_empty: 'Produkt auswählen und Menge eingeben',
        search: {
            placeholder: 'Nach Name suchen',
            tooltip: 'Scanner öffnen',
            Warehouse: "Lager",
        },
        column: {
            invoice: "Rechnung",
            image: 'Foto',
            name: 'Name',
            price: 'Preis',
            buying_price: 'Einkaufspreis',
            selling_price: 'Verkaufspreis',
            sku: 'SKU',
            stock: 'Lagerbestand',
            quantity: 'Menge',
            latest_stock: 'Verbleibend',
            product_deleted: 'Produkt wurde gelöscht',
            info_not_found: 'Information nicht verfügbar',
            expired_date: 'Ablaufdatum'
        },
        no_product: 'Keine Produkte verfügbar',
        no_product_subtitle: 'Fügen Sie Ihr erstes Produkt hinzu, um Lagerbestand, Preise und Verkäufe zu verfolgen.',
        create_first_product: 'Erstes Produkt erstellen',
        add_product: {
            sku: 'Produktcode',
            sku_placeholder: 'Produktcode. Beispiel: 12345',
            name: 'Produktname',
            name_placeholder: 'Produktname eingeben',
            initial_stock: 'Anfangsbestand',
            initial_stock_placeholder: 'Anfangsbestand eingeben',
            buying_price: 'Einkaufspreis',
            buying_price_placeholder: 'Einkaufspreis eingeben',
            selling_price: 'Verkaufspreis',
            selling_price_placeholder: 'Verkaufspreis eingeben',
            category: 'Kategorie',
            category_placeholder: 'Kategorie auswählen',
            add_selling_price: 'Großhandelspreis hinzufügen',
            expired_date: 'Ablaufdatum',
            expired_date_placeholder: 'Datum auswählen',
            description: 'Beschreibung',
            description_placeholder: 'Beschreibung eingeben',
            Warehouse: "Lager",
        },
        choose_selling_price: 'Verkaufspreis wählen',
        selling_price: 'Verkaufspreis',
        total_product: 'Gesamtprodukte',
        total_quantity: 'Gesamtlagerbestand',
        total_buying_price: 'Gesamteinkaufspreis',
        total_selling_price: 'Gesamtverkaufspreis',
        message: {
            required_name: 'Produktname ist erforderlich',
            required_sku: 'SKU ist erforderlich',
            required_category: 'Kategorie ist erforderlich',
            required_quantity: 'Anfangsbestand ist erforderlich',
            invalid_input_qty: 'Ungültige Lagerbestandsmenge',
            required_buying_price: 'Einkaufspreis ist erforderlich',
            required_selling_price: 'Verkaufspreis ist erforderlich',
            required_selling_price_name: 'Name des Verkaufspreises ist erforderlich',
            required_selling_price_price: 'Verkaufspreis ist erforderlich'
        },
        viewMore: 'Mehr anzeigen',
        WarehouseDetails: 'Lagerdetails',
        WarehouseName: 'Lagername',
        AddWarehouse: 'Lager hinzufügen',
        WarehouseQty: 'Lagerbestand',
        Warehouse: 'Lager',
        Warehouses: 'Lager',
        Variants: 'Varianten',
        VariantName: 'Variantenname',
        productVariant: 'Produktvarianten',
        AddVariant: 'Varianten hinzufügen',
        TranferItem: 'Artikel übertragen',
        AddUnit: 'Neue Einheit',
        InitialStkWarehouse: 'Anfangsbestand erforderlich, um Varianten hinzuzufügen',
        InitialStockinwarehouse: 'Anfangsbestand im Lager',
        TotalQuantity: 'Gesamtmenge:',
        AddNote: 'Notiz hinzufügen (Selbstkostenpreis)',
        AddNotetitle: 'Notiz hinzufügen',
        VariantSuccessMessage: 'Produktvariante erfolgreich aktualisiert',
        Next: 'Weiter',
        Submit: 'Einreichen',
        INACTIVE: 'INAKTIV',
        errorone: 'Hoppla! Die angeforderte Menge für',
        errortwo:
            'stimmt nicht mit den zugewiesenen Lagerbeständen überein. Bitte passen Sie die Menge an oder füllen Sie nach.',
        SelectWarehouse: 'Lager auswählen',
        SelectVariant: 'Variante auswählen',
        Discount: 'Rabatt',
        DiscountDetails: 'Rabattdetails',
        FinalPrice: 'Endpreis',
        DiscountType: 'Rabattart',
        DiscountPer: 'Rabatt %',
        DiscountValue: 'Rabattwert',
        Discountonprice: 'ಬೆಲೆಯ ಮೇಲೆ ರಿಯಾಯಿತಿ',
        Discountondiscount: 'ರಿಯಾಯಿತಿಯ ಮೇಲೆ ರಿಯಾಯಿತಿ',
        AdditionalDiscount: 'ಹೆಚ್ಚುವರಿ ರಿಯಾಯಿತಿ',
        SellingPrice: 'ಮಾರಾಟದ ಬೆಲೆ:',
        Save: 'ಉಳಿಸಿ',
        OnOriginalPrice: 'Zum Originalpreis',
        OnDiscountedPrice: 'Zum reduzierten Preis',
        columnSelector: {
            title: 'Spalten anzeigen',
            columnsButton: 'Spalten',
            costPrice: 'Einstandspreis',
            sellingPrice: 'Verkaufspreis',
            sku: 'SKU',
            warehouse: 'Lagerhaus',
            categories: 'Kategorien',
            safetyStock: 'Sicherheitsbestand',
            attributes: 'Attribute',
            notes: 'Notizen',
            description: 'Beschreibung',
            more: 'mehr',
            attribute: 'Attribut',
            attributesTitle: 'Attribute',
            categoriesTitle: 'Kategorien',
            skuAliases: 'SKU-Aliase'
        }
    },
    note: {
        title: 'Notizen',
        add: 'Notiz hinzufügen',
        no_note: 'Keine Notizen verfügbar'
    },
    settings: {
        category: 'Kategorie',
        language: 'Sprache',
        switch_business: 'Geschäft wechseln',
        currencySelect: 'Währung',
        languageChangeSuccess: "Währung erfolgreich aktualisiert",
        languageChangeErrorMessage: "Beim Aktualisieren der Währung ist ein Fehler aufgetreten",
        currencyAdded: "Währung erfolgreich hinzugefügt",
        currencyDelete: "Währung erfolgreich gelöscht",
        Selectyourpreferredlanguage: "Wählen Sie Ihre bevorzugte Sprache",
    },
    category: {
        category_list: {
            title: 'Produktkategorien'
        },
        add_category: {
            button: 'Neue Kategorie',
            title: 'Neue Kategorie hinzufügen'
        },
        edit_category: {
            title: 'Kategorie bearbeiten'
        },
        name: 'Kategoriename',
        name_placeholder: 'Kategoriename eingeben',
        no_category: 'Keine Kategorien verfügbar'
    },
    staff: {
        add: 'Personal hinzufügen',
        edit: 'Personal bearbeiten',
        access: {
            stock: 'Bestand',
            add_product: 'Neues Produkt hinzufügen',
            edit_product: 'Produkt bearbeiten',
            delete_product: 'Produkt löschen',
            view_capital_price: 'Kostenpreis anzeigen',
            add_category: 'Neue Kategorie hinzufügen',
            edit_category: 'Kategorie bearbeiten',
            delete_category: 'Kategorie löschen',
            add_supplier: 'Neuen Anbieter hinzufügen',
            edit_supplier: 'Anbieter bearbeiten',
            delete_supplier: 'Anbieter löschen',
            add_customer: 'Neuen Kunden hinzufügen',
            edit_customer: 'Kunde bearbeiten',
            delete_customer: 'Kunden löschen',
            add_staff: 'Personal hinzufügen',
            edit_staff: 'Personal bearbeiten',
            delete_staff: 'Personal löschen',
            change_business_profile: 'Geschäftsprofil ändern',
            access_by_product_category: 'Zugriff nach Produktkategorie',
            no_category_message: 'Sie haben keine Kategorie hinzugefügt. Bitte fügen Sie eine Kategorie hinzu.',
            expenses: 'Ausgaben',
            view_expenses: 'Ausgaben anzeigen',
            add_expenses: 'Ausgaben hinzufügen',
            edit_expenses: 'Ausgaben bearbeiten',
            delete_expenses: 'Ausgaben löschen',
            warehouse: 'Lager',
            add_new_warehouse: 'Neues Lager hinzufügen',
            edit_warehouse: 'Lager bearbeiten',
            delete_warehouse: 'Lager löschen',
            transfer_warehouse: 'Lager übertragen',
            transfer_warehouse_approval: 'Genehmigung für Lagerübertragung',
            access_by_warehouse: 'Zugang nach Lagerhaus',
            no_warehouse_message: 'Sie haben kein Lager hinzugefügt. Bitte fügen Sie eine Lagerliste hinzu.',
            purchase_order: "Bestellung",
            purchase_order_creation: "Bestellungserstellung",
            purchase_order_edit: "Bestellung bearbeiten",
            purchase_order_cancel: "Bestellung stornieren",
            purchase_order_reopen: "Bestellung erneut öffnen",
            purchase_order_receive: "Bestellung empfangen",
            sales_order: "Verkaufsauftrag",
            sales_order_creation: "Verkaufsauftragserstellung",
            sales_order_edit: "Verkaufsauftrag bearbeiten",
            sales_order_cancel: "Verkaufsauftrag stornieren",
            sales_order_reopen: "Verkaufsauftrag erneut öffnen",
            sales_order_receive: "Verkaufsauftrag versendet",
            purchase_order_approval: "Bestellgenehmigung",
            sales_order_approval: "Verkaufsauftragsgenehmigung",
            can_do_available_warehouse: "Verfügbares Lager",
            add_batch: "Genehmigung der Batch-Erstellung"
            ,
            notification: 'Benachrichtigung',
            staffNotification: 'Benachrichtigung aktivieren',
            assignee: "Zugewiesener",
        },
        no_staff: 'Kein Personal verfügbar.'
    },
    code: {
        title: 'Neues Personal hinzugefügt!',
        subtitle: 'Teilen Sie den Einladungscode unten, um beizutreten:',
        valid: 'Code ist nur 48 Stunden gültig',
        share: 'Auf WhatsApp teilen',
        copied: 'Kopiert!',
        invalid: 'Ungültiger Code!'
    },
    history: {
        no_history: 'Keine Historie.',
        detail: {
            remove: 'Historie entfernen',
            confirm: 'Diese Funktion wirkt sich auf den bestehenden Bestand, die Historie und die Berichte aus.'
        },
        no_history_selected: "No se ha seleccionado ningún historial",
        select_history_hint: "Haz clic en un historial de la lista para ver los detalles",
        select_from_left: "Selecciona desde el panel izquierdo",
    },
    supplier: {
        add: {
            title: 'Lieferant hinzufügen'
        },
        edit: {
            title: 'Lieferant bearbeiten'
        },
        new: 'Neuer Lieferant',
        no_supplier: 'Keine Lieferanten verfügbar.',
        bank: {
            title: 'Bankdaten'
        },
        note: 'Notizen',
        form: {
            name: {
                label: 'Lieferantenname',
                placeholder: 'Lieferantenname eingeben',
                placheolder_not_mandatory: 'Name eingeben (optional)',
                error: {
                    required: 'Name darf nicht leer sein'
                }
            },
            contact: {
                label: 'Kontakt Nummer',
                placeholder: '91934554432',
                error: {
                    required: 'Kontakt Nummer darf nicht leer sein',
                    invalid: 'Ungültige Nummer. Muss Ländervorwahl enthalten'
                }
            },
            bank_name: {
                label: 'Bankname',
                placeholder: 'Bankname eingeben'
            },
            bank_account_name: {
                label: 'Kontoinhaber Name',
                placeholder: 'Kontoinhaber Name eingeben'
            },
            bank_account_number: {
                label: 'Kontonummer',
                placeholder: 'Kontonummer eingeben'
            },
            note: {
                label: 'Notizen',
                placeholder: 'Notizen hinzufügen'
            },
            openingBalance: {
                addBtn: 'Eröffnungssaldo hinzufügen',
                label: 'Eröffnungssaldo',
                placeholder: 'Eröffnungssaldo eingeben',
                error: {
                    negative: 'Eröffnungssaldo darf nicht negativ sein'
                }
            }
        },
        choose: 'Lieferanten auswählen'
    },
    customer: {
        add: {
            title: 'Kunden hinzufügen'
        },
        edit: {
            title: 'Kunden bearbeiten'
        },
        new: 'Neuer Kunde',
        no_customer: 'Keine Kunden verfügbar.',
        note: 'Notizen',
        form: {
            name: {
                label: 'Kundenname',
                placeholder: 'Kundenname eingeben',
                placheolder_not_mandatory: 'Name eingeben (optional)',
                error: {
                    required: 'Name darf nicht leer sein'
                }
            },
            contact: {
                label: 'Kontakt Nummer',
                placeholder: '91934554432',
                error: {
                    required: 'Kontakt Nummer darf nicht leer sein',
                    invalid: 'Ungültige Nummer. Muss Ländervorwahl enthalten'
                }
            },
            address: {
                label: 'Adresse',
                placeholder: 'Adresse eingeben'
            },
            note: {
                label: 'Notizen',
                placeholder: 'Notizen hinzufügen'
            },
            openingBalance: {
                addBtn: 'Eröffnungssaldo hinzufügen',
                label: 'Eröffnungssaldo',
                placeholder: 'Eröffnungssaldo eingeben',
                error: {
                    negative: 'Eröffnungssaldo darf nicht negativ sein'
                }
            }
        },
        choose: "Kunde auswählen",
        report: {
            view: 'Käuferbericht anzeigen',
            title: 'Käuferbericht',
            no_report: 'Es gibt keine Berichte für Käufer am ausgewählten Datum.',
            column: {
                name: 'Name',
                total_transaction: 'Gesamttransaktionen',
                total_amount: 'Gesamtumsatz',
                total_profit: 'Gesamtgewinn'
            }
        }
    },
    confirm_delete: 'Sind Sie sicher, dass Sie diese Daten löschen möchten?',
    report: {
        title: 'Bericht'
    },
    accounting: {
        download_pdf_report: 'PDF herunterladen',
        title: 'Buchhaltung',
        view_report: 'Finanzbericht anzeigen',
        dashboard_title: 'Finanzbericht',
        stats: 'Statistiken',
        accounting_report: 'Buchhaltungsbericht',
        filter: {
            date: {
                placeholder: 'Datum auswählen',
                submit: 'Anwenden',
                cancel: 'Filter zurücksetzen'
            },
            timeframe: {
                day: 'Täglich',
                week: 'Wöchentlich',
                month: 'Monatlich',
                year: 'Jährlich'
            }
        },
        total_sales: 'Gesamtumsatz',
        total_purchases: 'Gesamtkäufe',
        total_profit: 'Gesamtgewinn',
        total_expenses: 'Gesamtausgaben',
        assets_value: 'Aktueller Vermögenswert',
        total_current_cogs_value: 'Aktueller COGS-Gesamtwert',
        current_asset_selling_price: 'Aktueller Vermögensverkaufspreis',
        total_selling_price: 'Gesamtverkaufspreis',
        table: {
            date: 'Datum',
            sales: 'Umsatz',
            purchases: 'Einkäufe',
            profit: 'Gewinn',
            expenses: 'Ausgaben'
        },
        no_data: 'Keine Daten verfügbar.'
    },
    stock_report: {
        title: 'Bestandsbericht',
        view: 'Bestandsbericht anzeigen',
        no_report: 'Keine Bestandsaufzeichnungen für das ausgewählte Datum oder das ausgewählte Personal.',
        allStaffPlaceHolder: 'Alle Mitarbeiter',
        column: {
            total_product: 'Aktuelle Produkttypen',
            total_product_quantity: 'Gesamtanzahl der aktuellen Produkte'
        }
    },
    subscription: {
        paywall_small: {
            title: 'VIP-Funktion',
            description:
                'Ihre Testphase für diese Funktion ist abgelaufen. Unterstützen Sie die Entwicklung dieser lokalen App, indem Sie ein Abonnement abschließen.',
            button: 'Abonnementpläne anzeigen'
        }
    },
    payment: {
        order: {
            title: 'Zahlung'
        }
    },
    imageUploadMessage: {
        uploadSize: 'Die Bildgröße darf 5 MB nicht überschreiten!',
        failedMessage: 'Das Hochladen des Artikelbildes ist fehlgeschlagen, bitte versuchen Sie es erneut!',
        successUpload: 'Das Bild wurde erfolgreich hochgeladen!',
        failedUIError: 'Das Löschen des Bildes ist fehlgeschlagen, bitte versuchen Sie es erneut!',
        SuccessErrorImage: 'Das Bild wurde erfolgreich gelöscht!'
    },
    productColumns: {
        SKULabel: 'SKU',
        nameLabel: 'Produktname',
        categoryLabel: 'Kategorie',
        BuyingPriceLabel: 'Einkaufspreis',
        SellingLabel: 'Verkaufspreis',
        StockLabel: 'Bestand'
    },
    historyColumns: {
        Transactionlabel: 'Transaktionstyp',
        Locallabel: 'Lokale Zeit',
        Createdlabel: 'Erstellt von',
        Vendorlabel: 'Lieferantenname',
        Buyerlabel: 'Käufername',
        SKUlabel: 'SKU',
        Productlabel: 'Produktname',
        Categorylabel: 'Kategorie',
        Buyinglabel: 'Einkaufspreis',
        Sellinglabel: 'Verkaufspreis',
        Initiallabel: 'Anfangsbestand',
        Finallabel: 'Endbestand',
        Stocklabel: 'Bestandsänderung'
    },
    stockReportColumns: {
        skuLabel: 'SKU',
        productNameLabel: 'Produktname',
        categoryLabel: 'Kategorie',
        buyingPriceLabel: 'Einkaufspreis',
        sellingPriceLabel: 'Verkaufspreis',
        stockInLabel: 'Eingehender Bestand',
        stockOutLabel: 'Ausgehender Bestand',
        remainingStockLabel: 'Verbleibender Bestand',
        openStockLabel: 'Anfangsbestand',
        weightedAverageCost: 'Gewichtete Durchschnittskosten',
        weightedAverageCostLabel: 'Gewichtete Durchschnittskosten',
        weightedAverageValueLabel: 'Gewichteter Durchschnittswert'
    },
    accountingReportColumns: {
        dateRange: 'Datumsbereich',
        reportingPeriod: 'Berichtszeitraum',
        reportGenerate: 'Bericht generieren',
        warehouse: 'Lagerhaus',
        labelDate: 'Datum',
        labelSales: 'Verkäufe',
        labelPurchases: 'Einkäufe',
        labelProfit: 'Gewinn',
        labelExpenses: 'Ausgaben',
        reportOptions: 'Berichtsspalten',
        summaryCards: 'Zusammenfassungs-Karten',
        grandTotal: 'Gesamtsumme',
        continued: 'Forts.',
        subtotal: 'Zwischensumme',
        page: 'Seite'
    },
    customerReportColumns: {
        labelName: 'Name',
        labelTotalTransaction: 'Gesamttransaktionen',
        labelTotalSales: 'Gesamtverkäufe',
        labelTotalProfit: 'Gesamtgewinn'
    },
    scannerDialog: {
        finished: 'Fertig',
        reduce: 'Reduzieren',
        successfull: 'Erfolgreich',
        searching: 'Suche...',
        title: 'Scanner aktiv. Richten Sie ihn auf den Barcode!'
    },
    historyFilter: {
        SelectBuyer: 'Käufer auswählen',
        SelectVendor: 'Lieferanten auswählen'
    },
    productStockFilter: {
        StockLowtoHigh: 'Bestand von niedrig nach hoch',
        StockHightoLow: 'Bestand von hoch nach niedrig',
        AlphabetAZ: 'Alphabet A-Z',
        AlphabetZA: 'Alphabet Z-A'
    },
    minimizeTitle: 'Scanner aktiv',
    security_guarantee: {
        title: 'Datensicherheit garantiert'
    },
    invoice: {
        invoicePlaceholder: 'Rechnungsnummer',
        invoiceTitle: 'Rechnung',
        manageInvoiceAddress: 'Rechnungsadresse verwalten',
        selectOrManageAddresses: 'Benutzerdefinierte Rechnungsadressen auswählen, bearbeiten oder erstellen',
        useBusinessProfileAddress: 'Unternehmensprofiladresse verwenden',
        noCustomAddressesFound: 'Keine benutzerdefinierten Adressen hinzugefügt',
        createCustomAddressDesc: 'Fügen Sie benutzerdefinierte Abrechnungs- oder Filialadressen hinzu, um sie auf Ihren Rechnungen anstelle der Standard-Unternehmensdaten zu drucken.',
        defaultFromBusinessProfile: 'Standard aus Unternehmensprofil',
        editInvoiceAddress: 'Rechnungsadresse bearbeiten',
        createNewInvoiceAddress: 'Neue Rechnungsadresse erstellen',
        logoHeaderImage: 'Logo / Kopfzeilenbild',
        deleteInvoiceAddress: 'Rechnungsadresse löschen?',
        deleteAddressConfirmText: 'Möchten Sie diese Rechnungsadresse wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.'
    },
    ManageInvoiceAddress: 'Rechnungsadresse verwalten',
    SelectOrManageAddresses: 'Benutzerdefinierte Rechnungsadressen auswählen, bearbeiten oder erstellen',
    UseBusinessProfileAddress: 'Unternehmensprofiladresse verwenden',
    CreateNewAddress: 'Neue Adresse erstellen',
    UpdatingList: 'Liste wird aktualisiert...',
    NoCustomAddressesFound: 'Keine benutzerdefinierten Adressen hinzugefügt',
    CreateCustomAddressDesc: 'Fügen Sie benutzerdefinierte Abrechnungs- oder Filialadressen hinzu, um sie auf Ihren Rechnungen anstelle der Standard-Unternehmensdaten zu drucken.',
    DefaultFromBusinessProfile: 'Standard aus Unternehmensprofil',
    EditInvoiceAddress: 'Rechnungsadresse bearbeiten',
    CreateNewInvoiceAddress: 'Neue Rechnungsadresse erstellen',
    LogoHeaderImage: 'Logo / Kopfzeilenbild',
    UploadingImage: 'Bild wird hochgeladen...',
    UploadImage: 'Bild hochladen',
    BusinessName: 'Unternehmensname',
    AddressDetails: 'Adressdetails',
    PhoneNumber: 'Telefonnummer',
    EmailAddress: 'E-Mail-Adresse',
    DeleteInvoiceAddress: 'Rechnungsadresse löschen?',
    DeleteAddressConfirmText: 'Möchten Sie diese Rechnungsadresse wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.',

    stocklowreport: {
        no_stocklowreport_one: 'Keine Artikel mit Lagerbestandsicherheits-Einstellungen vorhanden.',
        no_stocklowreport_two: 'Bitte fügen Sie die Sicherheitsmenge hinzu.',
        currentStock: 'Aktueller Bestand',
        safetyStock: 'Sicherheitsbestand',
        pricing: 'Preisgestaltung',
        costPrice: 'Einkaufspreis',
        sellingPrice: 'Verkaufspreis',
        productInfo: 'Produktinformationen',
        category: 'Kategorie',
        description: 'Beschreibung',
        no_description: 'Keine Beschreibung hinzugefügt',
        variants: 'Varianten',
        unitsOnHand: 'verfügbare Einheiten',
        minimumThreshold: 'Mindestgrenze',
        adjust: 'Anpassen',
        all: 'Alle',
        lowStock: 'Niedriger Bestand',
        variantsDetails: 'Variantendetails',
        qty: 'Menge',
        addSafetyStock: 'Sicherheitsbestand hinzufügen',
        searchByNameSku: 'Nach Name/SKU suchen',
        safetyStockShort: 'S',
        warehouseSafetyStock: 'Sicherheitsbestand des Lagers'
    },
    low_alert_stock: 'Geben Sie die Sicherheitsmenge ein',
    lowStockAlertNotify: 'Sie erhalten eine Benachrichtigung, wenn der Lagerbestand unter die festgelegte Menge fällt.',
    applyButtonStockAlert: 'Anwenden',
    cancelButtonStockAlert: 'Abbrechen',
    searchProductLabel: 'Produkt suchen...',
    successfullyAddedSafetyStock: 'Sicherheitsbestand erfolgreich aktualisiert',
    safety_Stock: 'Sicherheitsbestand',
    safety_stock_placeholder: 'Sicherheitsbestand eingeben',
    lowStockDetailsInfo: {
        ProductCode: 'Produktcode',
        SafetyStock: 'Sicherheitsbestand',
        Stock: 'Bestand',
        CostPrice: 'Kostenpreis',
        SellingPrice: 'Verkaufspreis',
        Category: 'Kategorie',
        Description: 'Beschreibung',
        ExpirationDate: 'Verfallsdatum'
    },
    CustomLang: {
        Attribute: 'Attribut',
        AddAttribute: 'Attribut hinzufügen',
        EditAttribute: 'Attribut bearbeiten',
        CustomLabePlaceholder: 'Attributnamen eingeben',
        CustomLabePlaceholderSelect: 'Typ auswählen',
        AddMoreAttribute: 'Mehr Attribute hinzufügen',
        ItemAttribute: 'Artikelattribut',
        TableName: 'Name',
        TableType: 'Typ',
        TableAction: 'Aktion',
        TableDelete: 'Löschen',
        TableEdit: 'Bearbeiten',
        deleteMessage: 'Attribut erfolgreich gelöscht',
        editSuccessMessage: 'Attribut erfolgreich aktualisiert',
        AddSuccessMessage: 'Attribut erfolgreich hinzugefügt',
        AddAtt: 'Hinzufügen',
        EditAtt: 'Bearbeiten',
        SubmitAtt: 'Wird gesendet...'
    },
    Expenses: {
        ExpensesTitle: 'Ausgaben',
        AddExpenses: 'Ausgaben hinzufügen',
        ExpenseCategory: 'Ausgabenkategorie',
        NoExpenseCategory: 'Keine Ausgabenkategorie',
        AddExpenseCategory: 'Ausgabenkategorie hinzufügen',
        SelectExpenseCategory: 'Ausgabenkategorie auswählen',
        NoExpenses: 'Keine Ausgaben',
        ExpensesSuccess: 'Ausgaben erfolgreich erstellt',
        ExpensesSuccessEdit: 'Ausgaben erfolgreich aktualisiert',
        ExpensesCategoryName: 'Name der Ausgabenkategorie',
        ExpensesSuccessDelete: 'Ausgaben erfolgreich gelöscht',
        TotalSpentThisWeek: 'Gesamtbetrag diese Woche ausgegeben',
        AddNEC: "Neue Ausgabenkategorie hinzufügen",
        NC: "Neue Ausgabenkategorie",
        EditNEC: "Ausgabenkategorie bearbeiten"
    },
    Manufacturing: {
        ProducedProduct: "Hergestelltes Produkt",
        QuantityManufactured: "Hergestellte Menge",
        UnitCost: "Stückkosten",
        RawMaterialsTotal: "Rohstoffe Gesamt",
        TotalManufacturingCost: "Gesamtherstellungskosten",
        NoRawMaterialsConsumed: "Keine Rohstoffe verbraucht.",
        CostBreakdown: "Kostenaufstellung",
        GeneratedBatch: "Erstellte Charge",
        StoredBinLocation: "Lagerort",
        NoManufacturingTransactionsFound: "Keine Herstellungstransaktionen gefunden",
        AddManufacture: 'Fertigungsdetails hinzufügen',
        Manufacturing: 'Fertigung',
        RawMaterials: 'Rohstoffe',
        AdditonCosts: 'Zusätzliche Kosten',
        RawMaterial: 'Rohstoff',
        AdditonCost: 'Zusatzkosten',
        TotalCost: 'Gesamtkosten',
        AddRawMaterial: 'Rohstoffe hinzufügen für',
        AddAdditonCost: 'Zusatzkosten hinzufügen für',
        AddMore: 'Mehr hinzufügen',
        Add: 'Hinzufügen',
        Update: 'Aktualisieren',
        Updating: 'Wird gesendet...',
        ProductRequired: 'Produkt ist erforderlich',
        QuantityRequired: 'Menge ist erforderlich',
        ChargeRequired: 'Kosten sind erforderlich',
        EstimatedCostRequired: 'Geschätzte Kosten sind erforderlich',
        PurchasePriceRequired: 'Einkaufspreis ist erforderlich',
        SelectCharge: 'Kosten auswählen',
        EstimatedCost: 'Geschätzte Kosten',
        SelectProduct: 'Ein Produkt auswählen',
        Quantity: 'Menge',
        ManufactureDetails: 'Fertigungsdetails',
        BuyingPrice: 'Einkaufspreis',
        LabourCharge: 'Arbeitskosten',
        ElectricityCost: 'Stromkosten',
        PackagingCharge: 'Verpackungskosten',
        LogisticCost: 'Logistikkosten',
        OtherCharges: 'Sonstige Kosten',
        Save: 'Details speichern',
        PurchasePrice: 'Einkaufspreis',
        Date: 'Datum',
        For: 'Für',
        PurchaseRate: 'Einkaufsrate (Preis)',
        Scrolltoloadmore: 'Scrollen, um mehr zu laden...',
        Noproductsfound: 'Keine Produkte gefunden',
        ManufacturingQuantity: 'Fertigungsmenge',
        ManufactureAddedSuccess: 'Fertigungsdetails erfolgreich aktualisiert'
    },
    Warehouses: {
        transferOrder: 'Artikel übertragen',
        AddTransferOrder: 'Übertragene Artikel hinzufügen',
        NewWarehouse: 'Neues Lager',
        newHead: 'Beginne mit der Verwaltung mehrerer Lager!',
        headTwo: 'Verfolge und verwalte dein Inventar nahtlos über mehrere Lager hinweg',
        EnableWarehouse: 'LAGER AKTIVIEREN',
        EnableWarehouse2: 'Lager aktivieren',
        OrganizationPrimary: 'Hauptlager der Organisation',
        Edit: 'Bearbeiten',
        AreEnableWarehouse: 'Bist du sicher, dass du das Lager aktivieren möchtest?',
        Confirm: 'Bestätigen',
        Cancel: 'Abbrechen',
        WarehouseCreatedSuccessfully: 'Lager erfolgreich erstellt',
        MarkAsOP: 'Als Hauptlager der Organisation markieren',
        MarkAsInAct: 'Als inaktiv markieren',
        MarkAsAct: 'Als aktiv markieren',
        MarkedAsInactive: 'Lager erfolgreich als inaktiv markiert',
        MarkedAsActive: 'Lager erfolgreich als aktiv markiert',
        MarkedAsOP: 'Lager erfolgreich als Hauptlager markiert',
        WareDeletedSuccess: 'Lager erfolgreich gelöscht',
        SuccessfullyUpdatedWarehouse: 'Lager erfolgreich aktualisiert',
        SuccessfullyCreatedWarehouse: 'Lager erfolgreich erstellt',
        EditWarehouse: 'Lager bearbeiten',
        AddWarehouse: 'Lager hinzufügen',
        WarehouseNameIsRequired: 'Lagername ist erforderlich',
        EnterWarehouseName: 'Lagernamen eingeben',
        EnterEmail: 'E-Mail eingeben',
        EnterPhoneNumber: 'Telefonnummer eingeben',
        Location: 'Standort...',
        name: 'Lagername',
        email: 'E-Mail',
        phoneNumber: 'Telefonnummer',
        location: 'Standort',
        ViewProducts: 'Produkte anzeigen',
        PageTitle: 'Lager'
    },
    Assets: {
        headerTitle: 'Vermögenswerte',
        addAssetMessage:
            'Fügen Sie hier Vermögenswerte hinzu. Um einen Vermögenswert einem Mitarbeiter zuzuweisen, gehen Sie zum Profil des Mitarbeiters.',
        addAsset: 'Vermögenswert hinzufügen',
        editAsset: 'Vermögenswert bearbeiten',
        assetCode: 'Vermögenswert-Code',
        assetName: 'Name des Vermögenswerts',
        assetCategory: 'Kategorie des Vermögenswerts',
        assetType: 'Typ des Vermögenswerts',
        serialNumber: 'Seriennummer',
        location: 'Standort',
        condition: 'Zustand',
        selectCondition: 'Zustand auswählen',
        fair: 'Angemessen',
        good: 'Gut',
        excellent: 'Ausgezeichnet',
        poor: 'Schlecht',
        notes: 'Notizen',
        submit: 'Absenden',
        submitting: 'Wird gesendet',
        noCategory: 'Keine Kategorie',
        selectCategory: 'Kategorie auswählen',
        addAssetCat: 'Kategorie für Vermögenswert hinzufügen',
        addAssetCatName: 'Name der Vermögenswert-Kategorie',
        edit: 'Bearbeiten',
        status: 'Status',
        createdAt: 'Erstellt am',
        viewAsset: 'Vermögenswert anzeigen',
        assignAsset: 'Vermögenswert zuweisen',
        conditionRet: 'Zustand (bei Rückgabe)',
        searchSelectAssets: 'Vermögenswert suchen/auswählen',
        assetAssigned: 'Vermögenswert erfolgreich zugewiesen',
        assetReturned: 'Vermögenswert erfolgreich zurückgegeben',
        selectAnAsset: 'Bitte wählen Sie einen Vermögenswert aus',
        action: 'Aktion',
        noAssetAssigned: 'Keine Vermögenswerte zugewiesen',
        reAssigned: 'Neu zuweisen',
        assignedAssetsList: 'Liste der zugewiesenen Vermögenswerte',
        viewHistory: "Verlauf anzeigen",
        history: "Asset-Verlauf",
        loadingHistory: "Verlauf wird geladen...",
        loadingMore: "Mehr wird geladen...",
        dateTime: "Datum & Uhrzeit",
        staff: "Mitarbeiter",
        AssignedBy: "Zugewiesen von",
        assign: "ZUWEISEN",
        return: "RÜCKGABE",
        unknown: "UNBEKANNT",
        noHistory: "Kein Verlauf für dieses Asset verfügbar.",
        enterReturnNote: "Notiz zur Rückgabe eingeben",
        returnNote: "Rückgabe-Notiz",
        enterAssignNote: "Notiz zur Zuweisung eingeben",
        assignNote: "Zuweisungs-Notiz",
        AddNAC: "Neue Anlagenkategorie hinzufügen",
        EditNAC: "Anlagenkategorie bearbeiten",
        others: "Andere"
    },
    LedgerTransaction: {
        ledgerDetails: 'Details des Hauptbuchs',
        productName: 'Produktname',
        totalQty: 'Gesamtmenge',
        date: 'Datum',
        receivedAmt: 'Erhaltener Betrag',
        paid: 'Bezahlt',
        discount: 'Rabatt',
        balance: 'Saldo',
        more: 'mehr',
        total: 'Gesamt',
        ledgerupdatedsuccessfully: 'Hauptbuch erfolgreich aktualisiert',
        ledgeraddedsuccessfully: 'Hauptbuch erfolgreich hinzugefügt',
        viewLedger: 'Hauptbuch anzeigen',
        edit: 'Bearbeiten',
        create: 'Erstellen',
        Recieved: 'Empfangen [Wareneingang]',
        payMode: 'Zahlungsart',
        Refno: 'Referenznummer'
    },
    ExtraField: {
        attachment: "Anhang",
        acceptOnlyImg: "Nur Bilder akzeptieren.",
        addAttribute: "Attribut hinzufügen",
        acceptImgAndDoc: "Bilder und Dokumente akzeptieren."
    },
    phoneInvoiceDownload: {
        Variant: "Variante",
        Warehouse: "Lager",
        Bin: "Bin",
        Batch: "Charge",
        Attributes: "Attribute"
    },
    FewLocal: {
        SelectBin: "Bin auswählen",
        Live: "Live",
        Monitorinventorystocklevels: "Bestand, Bewegungen und Bestandsniveaus überwachen",
        StockControlCentre: "Bestandssteuerungszentrale",
        Nochartdataavailable: "Keine Diagrammdaten verfügbar",
        Disabled: "Deaktiviert",
        Enabled: "Aktiviert"
    },
    ImportExcel: {
        ImportStockfromExcel: "Bestand aus Excel importieren",
        DragDrop: "Ziehen Sie Ihre ausgefüllte Excel-Datei hierher oder klicken Sie zum Durchsuchen",
        DT: "Vorlage herunterladen",
        GB: "Zurück",
        Downloading: "Wird heruntergeladen...",
        ChangeFile: "Datei ändern",
        ReadingExcelfile: "Excel-Datei wird gelesen...",
        Processing: "Wird verarbeitet...",
        submitUpdateStock: "Absenden & Bestand aktualisieren",
        downloadLatestTemplate: "Neueste Vorlage herunterladen",
        loginRequired: "Anmeldung erforderlich"
    },
    stockForm: {
        recordPaymentNow: "Zahlung jetzt erfassen",
        recordPaymentDescCustomer: "Geben Sie den vom Kunden gezahlten Betrag ein",
        recordPaymentDescSupplier: "Geben Sie den vom Lieferanten gezahlten Betrag ein",
        managePayments: "Zahlungen verwalten",
        invoice: "Rechnung",
        challan: "Lieferschein",
        recordPayment: "Zahlung erfassen",
        payableAmount: "Zahlbarer Betrag",
        paidAmount: "Bezahlter Betrag",
        paymentMethod: "Zahlungsmethode",
        paymentDate: "Zahlungsdatum",
        reference: "Referenz",
        billId: "Rechnungsnummer",
        importExcel: "Aus Excel importieren",
        noThanks: "Nein, danke",
        checkHistory: "Verlauf prüfen",
        wantViewHistory: "Möchten Sie Ihren Verlauf anzeigen?",
        enterPayable: "Zahlbaren Betrag eingeben",
        enterPaid: "Bezahlten Betrag eingeben",
        selectPayment: "Zahlungsmethode auswählen",
        attachment: "Anhang",
        note: "Notiz"
    },
    HistoryEdit: {
        products: "Produkte",
        add_product: "Produkt hinzufügen",
        paidAmountInvalidMessage: "Der bezahlte Betrag darf nicht größer als der zahlbare Betrag sein",
        removingText: "Das Entfernen dieses Produkts macht die während dieser Transaktion vorgenommenen Lageränderungen rückgängig.",
        remove: "Entfernen"
    },
    ExcelProduct: {
        uploadFile: "Datei hochladen",
        dragDrop: "Ziehen Sie Ihre Excel-Datei hierher oder klicken Sie zum Hochladen.",
        parsingFile: "Datei wird analysiert",
        fileSelected: "Datei ausgewählt",
        reviewImportedData: "Überprüfen Sie die importierten Daten unten. Spalten werden, wenn möglich, automatisch zugeordnet.",
        changeFile: "Datei ändern",
        back: "Zurück",
        invalidFileType: "Bitte laden Sie eine gültige Excel-Datei hoch (.xlsx oder .xls)",
        parseExcelError: "Excel-Analysefehler:",
        noData: "Die hochgeladene Excel-Datei enthält keine Daten.",
        failedToRead: "Excel-Datei konnte nicht gelesen werden. Bitte versuchen Sie es erneut.",
        Nodata: "KEINE_DATEN",
        unableToRead: "Datei kann nicht gelesen werden.",
        buyingMustNumber: "Einkaufspreis muss eine Zahl sein",
        sellingMustNumber: "Verkaufspreis muss eine Zahl sein",
        mustBeNumber: "muss eine Zahl sein",
        bulkUploadfailed: "Massen-Upload fehlgeschlagen",
        importFromExcel: "Aus Excel importieren",
        generating: "Wird erstellt...",
        downloadTemplate: "Vorlage herunterladen",
        uploading: "Wird hochgeladen...",
        done: "Fertig",
        requiredField: "{field} ist erforderlich",
        bulkUpload: "Massen-Upload",
        duplicateSku: "Doppelte SKU gefunden",
        uploadedSuccessfully: "Alle Produkte wurden erfolgreich hochgeladen!",
        uploadCompleteIssues: "Upload abgeschlossen, jedoch mit Problemen",
        uploaded_products: "{count} Produkt(e) hochgeladen.",
        failed_products: "{count} fehlgeschlagen.",
        failed_items: "Fehlerhafte Einträge:"
    },
    Discount: {
        overallDiscount: "Gesamtrabatt",
        final: "Endbetrag",
        balanceDue: "Offener Betrag",
        tax: "Steuer"
    },
    ProductForm: {
        barcodeQuantity: "Barcode-Menge eingeben",
        baseUnit: "Basiseinheit (Primär)",
        addSecondaryUnit: "Sekundäre Einheit hinzufügen?",
        selectUnit: "Einheit auswählen",
        subUnitDetails: "Details der Untereinheit",
        subUnit: "Untereinheit",
        selectSubUnit: "Untereinheit auswählen",
        conversionRate: "Umrechnungsrate",
        exampleLogic: "Beispiellogik:",
        example: "Wenn Sie Stifte in Boxen verkaufen, legen Sie die Basiseinheit als Box fest und fügen Sie eine Untereinheit (Stück) mit einer Umrechnung von 50 hinzu. Das bedeutet, dass 1 Box 50 Stück enthält.",
        basePrice: "Grundpreis"
    },
    barcode: {
        settings: 'Barcode-Einstellungen',
        labelSize: 'Etikettengröße',
        customSize: 'Benutzerdefinierte Größe...',
        widthMm: 'Breite (mm)',
        heightMm: 'Höhe (mm)',
        showPrice: 'Verkaufspreis auf Etikett',
        noPrices: 'Keine Verkaufspreise für dieses Produkt konfiguriert.',
        preview: 'Vorschau',
        generate: 'Generieren',
        label: 'Etikett',
        singlePage: 'Einzelne Seite',
        downloadOptions: 'Download-Optionen',
        chooseLayout: 'Layout für Barcodes wählen',
        allInSinglePage: 'Alle Barcodes auf einer Seite hinzufügen.',
        allInA4Grid: 'Alles auf einer Seite',
        allInA4GridSub: 'Ordnet alle Barcodes in einem A4-Raster an',
        onePerPage: 'Einer pro Seite',
        onePerPageSub: 'Jeder Barcode auf einer eigenen Etikettenseite'
    },

    TransferItem: {
        transferItem: "Artikel übertragen",
        Date: "Datum",
        Reason: "Grund",
        enterReason: "Grund eingeben",
        Name: "Name",
        QuantityTransfered: "Übertragene Menge",
        SWarehouse: "Quelllager",
        SelectSWarehouse: "Quelllager auswählen",
        DWarehouse: "Ziellager",
        SelectDWarehouse: "Ziellager auswählen",
        CreatedBy: "Erstellt von",
        CreatedTime: "Erstellungszeit",
        UpdatedTime: "Aktualisierungszeit",
        NoOrderFound: "Keine Bestellungen gefunden",
        New: "Neu",
        WarehouseItemTransfer: "Lagerartikel-Transfer",
        TotalTransfers: "Gesamttransfers",
        EnterReason: "Grund eingeben",
        ItemDetails: "Artikeldetails",
        CurrentAvailable: "Aktuell verfügbar",
        TransferQty: "Transfermenge",
        SStock: "Quellbestand",
        DStock: "Zielbestand",
        addDescription: "Beschreibung hinzufügen",
        selectVariant: "Variante auswählen",
        addNewRow: "Neue Zeile hinzufügen",
        typeOrSelectItem: "Zum Suchen eingeben",
        scrollToLoadMore: "Scrollen für mehr",
        noProductsFound: "Keine Produkte gefunden",
        selectWarehouse: "Lager auswählen"
    },
    Sku: {
        searchSelectProduct: "Produkt suchen / auswählen",
        searchSelectSku: "SKU suchen / auswählen",
        noSkuFound: "Keine SKU gefunden"
    },
    HistoryPage: {
        addFilter: "Filter hinzufügen",
        filtersActive: "Alle Filter aktiv",
        noProducts: "Keine Produkte",
        download: "Herunterladen",
        recentlyUpdated: "Kürzlich aktualisiert",
    },
    StockPage: {
        challanNumber: "Lieferscheinnummer",
        subTotal: "Zwischensumme",
        totalTaxes: "Gesamt & Steuern",
        taxInclusive: "Inkl. Steuer",
        discountedValue: "Rabattierter Wert",
        taxValue: "Steuerwert",
        totalAmount: "Gesamtbetrag",
        close: "Schließen",
        addTax: "Steuer hinzufügen",
        label: "Bezeichnung",
        enterLabel: "Bezeichnung eingeben",
        taxRate: "Steuersatz",
        enterTaxRate: "Steuersatz eingeben",
        selectTaxRate: "Steuersatz auswählen",
        addNewTax: "Neuen Steuersatz hinzufügen",
        discountProducts: "Rabattierter Wert (Produkte)",
        taxProducts: "Steuerwert (Produkte)",
        clickAddPayment: "Klicken, um Zahlung hinzuzufügen",
        paidGreaterPayable: "Der bezahlte Betrag darf nicht größer als der fällige Betrag sein",
        vendorCompulsory: "Lieferant ist erforderlich, um die Zahlung zu erfassen",
        customerCompulsory: "Ein Kunde ist erforderlich, um die Zahlung zu erfassen",
        updateInvoiceFormat: "Rechnungsformat aktualisieren",
        updateChallanFormat: "Lieferscheinformat aktualisieren",
        addPrefix: "Präfix hinzufügen",
        prefix: "Präfix"
    },
    EditHistoryPage: {
        search_by_notes: "Nach Notizen suchen",
        alertMessage: "Diese Änderung wurde nur im Verlauf gespeichert und beeinflusst den aktuellen Lagerbestand nicht.",
        paymentDetails: "Zahlungsdetails",
        units: "Einheiten",
        customLabels: "Benutzerdefinierte Bezeichnungen",
        value: "Wert",
        Order_Info: "Bestellinformationen",
        percentage: "Prozentsatz",
        Stock_updates_on_submit: "Bestand beim Absenden aktualisieren",
        Summary: "Zusammenfassung"
    },
    historyCard: {
        paid: "BEZAHLT",
        partiallyPaid: "TEILWEISE BEZAHLT",
        billDate: "Rechnungsdatum",
        productDetails: "Produktdetails",
        paymentsHistory: "Zahlungshistorie",
        updatePayment: "Zahlung aktualisieren",
        discounts: "Rabatte",
        inclusive: "(inkl.)",
        discountOverall: "Rabattierter Wert (Gesamt)",
        dueAmount: "Fälliger Betrag",
        enterPaid: "Bezahlten Betrag eingeben",
        enterReference: "Referenz eingeben",
        enterNote: "Notiz eingeben",
        enterInvoice: "Rechnung eingeben",
        enterChallan: "Lieferschein eingeben",
        edit: "Bearbeitet"
    },
    printInvoice: {
        billTo: "Rechnung an",
        ref: "Referenz-Nr.",
        mode: "Modus",
        date: "Datum",
        amount: "Betrag",
        totalPaid: "Gesamt bezahlt"
    },
    Contact: {
        supplier_required: "Für den Wareneingang ist ein Lieferant erforderlich",
        customer_required: "Für den Warenausgang ist ein Kunde erforderlich",
        key: "Schlüssel",
        editHistory: "Verlauf bearbeiten",
        loading: "Wird geladen..."
    },
    AW: {
        availablewarehouse: "Verfügbares Lager",
        visibilityManagement: 'Sichtbarkeits-Management',
        availablewarehouses: "Verfügbare Lager",
        Active: "Aktiv",
        LWarehouse: "Lager werden geladen...",
        NWForthisProduct: "Keine Lager für dieses Produkt gefunden.",
        of: "von",
        WarehouseAvailabilty: "Lagerverfügbarkeit",
    },
    Currency: {
        searchCurrency: "Währungen suchen...",
        addCurrency: "Währung hinzufügen",
        addNewCurrency: "Neue Währung hinzufügen",
        editCurrency: "Währung bearbeiten",
        currencySymbol: "Währungssymbol",
        currencyName: "Währungsname",
        enterCurrencySymbol: "Währungssymbol eingeben",
        enterCurrencyName: "Währungsname eingeben"
    },
    NewReportLang: {
        DM: "Tägliche Bewegung",
        WR: "Lagerbericht",
        PDM: "Tägliche Produktbewegung",
        TBP: "Gesamter Kaufpreis",
        TPQ: "Gesamte Produktmenge",
        TP: "Gesamte Produkte",
        CS: "Aktueller Bestand",
        IV: "Bestandswert",
        DA: "Tagesdurchschnitt",
        TSI: "Gesamter Wareneingang",
        TSO: "Gesamter Warenausgang",
        TOR: "Umschlagsrate",
        Tv: "Gesamtwert",
        AST: "Aktive SKU-Verfolgung",
        UT: "Verfolgte Einheiten",
        SL: "Bestandsebene",
        Value: "Wert",
        IO: "EIN/AUS",
        T: "Umschlag",
        unitsD: "Einheiten/Tag",
        Sort: "Sortieren",
        Sort_by: "Sortieren nach",
        Units_available: "Verfügbare Einheiten",
        Units_unavailable: "Nicht verfügbare Einheiten",
        Current_assets: "Umlaufvermögen",
        Search: "Suchen",
        available: "Verfügbar",
        assigned: "Zugewiesen",
        AYSWD: "Möchten Sie wirklich löschen?",
        PTS: "Lager erfolgreich übertragen",
        AUS: "Vermögenswerte erfolgreich aktualisiert",
        ACS: "Vermögenswerte erfolgreich erstellt",
        VSP: "Verkaufspreis anzeigen",
        HUS: "Verlauf erfolgreich aktualisiert",
    },
    ReplacementReturn: {
        selectProduct: "Bitte wählen Sie ein Produkt aus",
        selectReplacementProduct: "Wählen Sie mindestens ein Ersatzprodukt aus",
        validQuantity: "Bitte geben Sie eine gültige Rückgabemenge ein",
        replacedSuccessfully: "Produkt erfolgreich ersetzt",
        returnSuccessfully: "Produkt erfolgreich zurückgegeben",
        failedProcess: "Verarbeitung fehlgeschlagen. Bitte versuchen Sie es erneut.",
        return: "Rückgabe",
        replace: "Ersetzen",
        typeSelectProduct: "Produkt eingeben oder auswählen...",
        returnQuantity: "Rückgabemenge",
        enterQuantity: "Menge eingeben",
        replacementDate: "Ersatzdatum",
        returnDate: "Rückgabedatum",
        chooseCustomer: "Kunden auswählen",
        additionalNotes: "Zusätzliche Hinweise hinzufügen...",
        replacementProducts: "Ersatzprodukte",
        addProducts: "Weitere Produkte hinzufügen",
        tapSelect: "Tippen, um aus verfügbaren Produkten auszuwählen",
        currently: "Aktuell",
        item: "Artikel",
        items: "Artikel",
        selected: "ausgewählt",
        selectedItems: "Ausgewählte Artikel",
        hideDetails: "Weniger Details anzeigen",
        showDetails: "Mehr Details anzeigen",
        product: "Produkt",
        priceLevel: "Preisstufe auswählen",
        customPrice: "Individuellen Preis eingeben",
        noReplaceHistory: "Kein Ersatzverlauf gefunden",
        replaceReturn: "Ersetzen und Zurückgeben",
        replaceReturnHistory: "Verlauf von Ersatz & Rückgabe"
    },
    OtherComponent: {
        mfgHistoryTitle: "Herstellungsverlauf",
        mfgHistoryDesc: "Hergestellte Bestandsprodukte verfolgen",
        dailyOperation: "Tägliche Abläufe",
        freqUsed: "Häufig verwendete Aktionen zum schnellen Aktualisieren von Datensätzen",
        manageCategory: "Kategorien verwalten",
        organizeCaterory: "Produkt-, Ausgaben- und Anlagekategorien organisieren und verwalten",
        businessRecord: "Geschäftsunterlagen",
        organizeRecord: "Ihre Geschäftsunterlagen organisieren und verwalten",
        trackHistory: "Verlauf verfolgen",
        completeTracking: "Vollständige Historie für Audit und Nachverfolgung",
        Verifyinventorycount: "Inventarzählung prüfen",
        Exchangerates: "Wechselkurse",
        Productiontracking: "Produktionsverfolgung",
        Fixedassetregister: "Anlagenregister",
        Storagelocations: "Lagerorte",
        warehouseAvailability: 'Produktverfügbarkeit auf Lagerebene',
        Logreviewspend: "Ausgaben protokollieren und überprüfen",
        Productgroupings: "Produktgruppierungen",
        Classifyexpenditures: "Ausgaben klassifizieren",
        Assetclassification: "Anlagenklassifizierung",
        Manageexchanges: "Wechselkurse verwalten",
        Returnauditlog: "Rückgabe-Audit-Log",
        Interlocationmoves: "Standortübergreifende Bewegungen",
        Manageoperationscategoriesrecordsandhistory: "Operationen, Kategorien, Datensätze und Historie verwalten"
    },
    no_permission_dialog: {
        title: 'Keine Berechtigung',
        historyDescription: "Sie haben keine Berechtigung, den Transaktionsverlauf einzusehen. Bitte wenden Sie sich an Ihren Administrator.",
        replacementHistoryDescription: "Sie haben keine Berechtigung, den Verlauf von Ersatz & Rückgabe einzusehen. Bitte wenden Sie sich an Ihren Administrator.",
        transferHistoryDescription: "Sie haben keine Berechtigung, den Transfer-Warehouse-Verlauf einzusehen. Bitte wenden Sie sich an Ihren Administrator."
    },
    OthersHistory: {
        title: "Verlauf verwalten",
        transferHistory: "Transferverlauf verwalten",
        transactionHistory: "Transaktionsverlauf verwalten",
        replacementHistory: "Ersatz- und Rückgabeverlauf verwalten"
    },
    catalog: {
        allCategories: "All",
        category: "Category",
        purchaseDescription: "Durchstöbern und kaufen Sie die vom Unternehmen geteilten Produkte.",
        description: "Durchstöbern Sie die vom Unternehmen geteilten Produkte.",
        productsAvailable: "Verfügbare Produkte",
        noImageAvailable: "Kein Bild verfügbar",
        productDetails: "Produktdetails",
        inStock: "auf Lager",
        availableVariants: "Verfügbare Varianten",
        options: "Optionen",
        orders: "Bestellungen"
        ,
        searchProducts: "Produkte suchen...",
        noProductsFound: "Keine Produkte gefunden",
        tryDifferentKeyword: "Versuchen Sie es mit einem anderen Suchbegriff",
        variants: "Varianten",
        stock: "Bestand",
        cart: "Warenkorb",
        products: "Produkte",
        viewCart: "Warenkorb anzeigen",
        backToProducts: "Zurück zu Produkten",
        yourCart: "Ihr Warenkorb",
        clear: "Leeren",
        cartEmpty: "Ihr Warenkorb ist leer",
        cartEmptyDesc: "Durchsuchen Sie den Katalog und fügen Sie Produkte hinzu.",
        browseProducts: "Produkte durchsuchen",
        selectedItems: "Ausgewählte Artikel",
        itemInCart: "Artikel im Warenkorb",
        itemsInCart: "Artikel im Warenkorb",
        customerDeliveryDetails: "Kunden- & Lieferdetails",
        fullName: "Vollständiger Name",
        enterFullName: "Geben Sie Ihren vollständigen Namen ein",
        deliveryAddress: "Lieferadresse",
        addressPlaceholder: "Straße, Gebäude, Stadt, PLZ...",
        orderNote: "Bestellnotiz (Optional)",
        orderNotePlaceholder: "Besondere Anweisungen oder Lieferhinweise...",
        paymentMode: "Zahlungsart",
        subtotal: "Zwischensumme",
        items: "Artikel",
        totalAmount: "Gesamtbetrag",
        orderOnWhatsApp: "Über WhatsApp bestellen 📲",
        orderPlaced: "Bestellung erfolgreich aufgegeben! 🎉",
        orderPlacedDesc: "Ihre Bestellung wurde erfasst und WhatsApp wurde geöffnet.",
        continueShopping: "Weiter einkaufen 🛍️",
        cartEmptyTitle: "Warenkorb leer",
        cartEmptyToast: "Bitte fügen Sie Produkte hinzu, bevor Sie zur Kasse gehen.",
        incompleteTitle: "Unvollständige Angaben",
        incompleteToast: "Bitte füllen Sie alle Pflichtfelder aus.",
        nameRequired: "Vollständiger Name ist erforderlich",
        addressRequired: "Lieferadresse ist erforderlich",
        catalogUnavailable: "Katalog derzeit nicht verfügbar",
        catalogUnavailableDesc: "Dieser Katalog ist derzeit nicht aktiv. Kontaktieren Sie das Unternehmen.",
        invalidCatalogLink: "Ungültiger Kataloglink 🚫",
        invalidCatalogDesc: "Diese Katalogseite enthält fehlende Informationen.",
        missing: "Fehlend",
        catalogSlug: "Katalog-Slug",
        goBackHome: "Zurück zur Startseite",
        inventoryManagement: "Bestandsverwaltung & Rechnungsstellung 🚀 Simply",
        enter: "Eingeben",
        select: "Auswählen",
        // Catalog Order translations
        catalogOrders: 'Katalogbestellungen',
        pending: 'Ausstehend',
        converted: 'Umgewandelt',
        cancelled: 'Storniert',
        totalRevenue: 'Gesamtwert',
        totalCatalogOrders: 'Online-Bestellungen gesamt',
        convertToSalesOrder: 'In Verkaufsauftrag umwandeln',
        date: 'Datum',
        status: 'Status',
        action: 'Aktion',
        searchOrders: 'Kunde oder Telefon suchen...',
        noMatchingOrders: 'Keine passenden Bestellungen gefunden',
        noStatusOrders: 'Keine {status} Bestellungen gefunden',
        tryDifferentSearch: 'Versuchen Sie es mit einem anderen Kundennamen oder einer anderen Telefonnummer.',
        noOrdersWithStatus: 'Derzeit gibt es keine Bestellungen mit dem Status {status}.',
        noOrdersYet: 'Noch keine Katalogbestellungen',
        noOrdersDescription: 'Bestellungen aus Ihrem Online-Katalog erscheinen hier.',
        guestCustomer: 'Gastkunde',
        item: 'Artikel',
        moreItems: '+{count} mehr',
        viewDetails: 'Details anzeigen',
        viewSalesOrder: 'Verkaufsauftrag anzeigen',
        cancelOrder: 'Bestellung stornieren',
        confirmCancelTitle: 'Katalogbestellung stornieren?',
        confirmCancelOrder: 'Sind Sie sicher, dass Sie diese Bestellung stornieren möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
        keepOrder: 'Nein, Bestellung behalten',
        confirmCancelAction: 'Ja, Bestellung stornieren',
        orderNotFound: 'Katalogbestellung nicht gefunden',
        orderNotFoundDescription: 'Diese Bestellung konnte nicht gefunden werden oder Sie haben keine Berechtigung, sie anzuzeigen.',
        backToCatalogOrders: 'Zurück zu Katalogbestellungen',
        placedOn: 'Aufgegeben am',
        totalItems: 'Artikel insgesamt',
        orderedProducts: 'Bestellte Produkte',
        itemDetails: 'Artikeldetails',
        quantity: 'Menge',
        unitPrice: 'Stückpreis',
        total: 'Gesamt',
        variant: 'Variante',
        customerInformation: 'Kundeninformationen',
        additionalFields: 'Zusätzliche Felder',
        fields: 'Felder',
    },
    stockNew: {
        Npay: "Noch keine Produkte hinzugefügt",
        emptydesc: "Wählen Sie ein Produkt aus Ihrem Katalog aus und geben Sie die eingehende Menge ein, um den Bestand zu erfassen.",
        tipText: "Tipp: Sie können auch eine Excel-Datei hochladen",
        OT: "Bestellsumme",
        Collapse: "Einklappen"
    },
    deleteBulk: {
        Bulkoperation: "Massenoperation",
        Applyproducts: "Aktionen auf mehrere Produkte anwenden",
        Bulkupload: "Massen-Upload",
        ImportCSVfile: "Produkte über Excel- oder CSV-Datei importieren",
        or: "oder",
        Bulkdelete: "Massenlöschung",
        Permanentlyallproducts: "Alle Produkte dauerhaft entfernen",
        IrrText: "Massenlöschung ist unwiderruflich. Exportieren Sie zuerst ein Backup, falls nötig.",
        SeP: "Ausgewählte Produkte",
        sP: "Produkt auswählen",
        DA: "Alle löschen",
        DP: "Produkte löschen",
        sL: "Alle auswählen",
        ASDE: "Möchten Sie wirklich alle Produkte außer",
        ASDAllP: "Möchten Sie wirklich alle Produkte löschen?",
        ASD: "Möchten Sie wirklich löschen",
        products: "Produkte",
        TACBU: "Diese Aktion kann nicht rückgängig gemacht werden.",
        LP: "Produkte werden geladen...",
        FM: "Mehr werden abgerufen...",
        NPF: "Keine Produkte gefunden.",
        LMP: "Mehr Produkte werden geladen..."
    },
    NewVariantModal: {
        Definevariantsassign: "Varianten definieren & Mengen zuweisen",
        Nothingallocated: "Nichts zugeteilt",
        Overallocated: "Überzuteilt",
        Fullyallocated: "Vollständig zugeteilt",
        Overby: "Über um",
        Allvariantsneedaname: "Alle Varianten benötigen einen Namen.",
        Reducequantities: "Mengen reduzieren.",
        Overallocatedby: "Überzuteilt um",
        Quantitiesmustmatchthetotalavailability: "Mengen müssen der Gesamtverfügbarkeit entsprechen.",
        Allocatequantitiesacrosswarehouses: "Mengen auf Lager verteilen",
        Notfullydistributed: "Nicht vollständig verteilt:",
        remaining: "verbleibend",
        Qty: "Menge",
        Inactive: "Inaktiv",
        left: "übrig"
    },
    ProductFormNew: {
        BasicInfo: "Grundinformationen",
        ProductImage: "Produktbild",
        Images: "Bilder",
        Pricing: "Preisgestaltung",
        Everypriceneedsbothalabelandanamount: "Jeder Preis benötigt sowohl ein Label als auch einen Betrag",
        AddalabellikeWholesaleorRetailtoidentifythisprice: "Fügen Sie ein Label wie „Großhandel“ oder „Einzelhandel“ hinzu, um diesen Preis zu kennzeichnen",
        AddMultiplePrice: "Mehrere Preise hinzufügen",
        NoPhotosLetAiFind: "Keine Fotos? Lassen Sie KI Produktbilder finden",
        AddProductImagesTitle: "Produktbilder hinzufügen",
        ChooseHowToAddPhotos: "Wählen Sie, wie Sie Fotos für dieses Produkt hinzufügen möchten:",
        SearchWithAi: "Mit KI suchen",
        SearchWithAiDesc: "Produktbilder automatisch mit KI suchen & auswählen",
        FilesFileExplorer: "Dateien (Dateiexplorer)",
        FilesFileExplorerDesc: "Bilder direkt von Ihrem Computer auswählen",
        AiProductImageFinder: "KI-Produktbildfinder",
        AiProductImageFinderDesc: "Bilder für Ihr Produkt suchen & auswählen",
        TypeProductNamePlaceholder: "Produktnamen eingeben...",
        SearchForYourProduct: "Nach Ihrem Produkt suchen",
        SearchForYourProductHint: `Versuchen Sie einen Marken- oder Produktnamen, z. B. "Kirkland Minoxidil"`,
        ImagesSelected: "Bilder ausgewählt",
        AddSelected: "Ausgewählte hinzufügen"
    },
    AttributeNewCustom: {
        Defineanewcustomfield: "Neues benutzerdefiniertes Feld definieren",
        AttributeName: "Attributname",
        DataType: "Datentyp",
        Noattributesfound: "Keine Attribute gefunden",
        ManageAttributes: "Attribute verwalten",
        Editordeleteexistingattributes: "Vorhandene Attribute bearbeiten oder löschen",
        UpdateAttribute: "Attribut aktualisieren",
        Saving: "Wird gespeichert..."
    },
    NewExpenses: {
        Noexpensesyet: "Noch keine Ausgaben",
        Addyourfirstexpensetostarttrackingyourspending: "Fügen Sie Ihre erste Ausgabe hinzu, um Ihre Ausgaben zu verfolgen.",
        TOTALEXPENSES: "GESAMTAUSGABEN",
        ENTRIES: "EINTRÄGE",
        BYCATEGORY: "NACH KATEGORIE",
        Nocategoriestodisplay: "Keine Kategorien zum Anzeigen",
        DateanfTime: "Datum & Uhrzeit"
    },
    PurchaseSales: {
        CancelOrder: "Bestellung stornieren",
        ReopenOrder: "Bestellung erneut öffnen",
        Reopen: "Erneut öffnen",
        ConfirmCancelOrder: "Sind Sie sicher, dass Sie diese Bestellung stornieren möchten?",
        ConfirmReopenOrder: "Sind Sie sicher, dass Sie diese Bestellung erneut öffnen möchten?",
        OrderCancelledSuccessfully: "Bestellung erfolgreich storniert.",
        OrderReopenedSuccessfully: "Bestellung erfolgreich erneut geöffnet.",
        CancelledBy: "Storniert von",
        Cancelled: "Storniert",
        ConvertPriceBasedOnUnitConversion: "Preis basierend auf Einheitenumrechnung umrechnen",
        MarkPaymentAsPending: "Zahlung als ausstehend markieren",
        PendingReceivableDesc: "Betrag als Forderung erfasst. Zahlung bei Eingang erfassen.",
        PendingPayableDesc: "Betrag als Verbindlichkeit erfasst. Zahlung bei Bezahlung erfassen.",
        SelectCustomerFirst: "Wählen Sie zuerst einen Kunden aus",
        SelectSupplierFirst: "Wählen Sie zuerst einen Lieferanten aus",
        SelectItemsFirst: "Bitte wählen Sie zuerst mindestens einen Artikel aus",
        PaymentMarkedPendingDesc: "Zahlung ist als ausstehend markiert. Deaktivieren Sie 'Zahlung als ausstehend markieren', um die Zahlung jetzt zu erfassen.",
        SelectCustomerAndItemFirst: "Bitte wählen Sie zuerst einen Kunden und mindestens einen Artikel aus",
        SelectSupplierAndItemFirst: "Bitte wählen Sie zuerst einen Lieferanten und mindestens einen Artikel aus",
        SelectCustomerProductFirst: "Zuerst Kunde & Produkt auswählen",
        SelectSupplierProductFirst: "Zuerst Lieferant & Produkt auswählen",
        Receivables: "Forderungen",
        Payables: "Verbindlichkeiten",
        AccessDenied: "Zugriff verweigert",
        YouDonthaeP: "Sie haben keine Berechtigung, diese Seite anzuzeigen. Wenn Sie glauben, dass dies ein Fehler ist, kontaktieren Sie bitte Ihren Administrator.",
        purchase: "Einkauf",
        sales: "Verkauf",
        Areyousureyouwantto: "Sind Sie sicher, dass Sie",
        Thisactionwillupdateitsstatus: "Diese Aktion aktualisiert den Status.",
        ReasonOPtional: "Grund (optional)",
        Enterareasonfor: "Geben Sie einen Grund ein für",
        optionalDot: "(optional)...",
        Reject: "Ablehnen",
        ConfirmOrder: "Bestellung bestätigen",
        RejectOrder: "Bestellung ablehnen",
        Previous: "Vorherige",
        First: "Erste",
        Order: "Bestellung",
        Items: "Artikel",
        Memo: "Notiz",
        SelectDateRange: "Datumsbereich auswählen",
        List: "Liste",
        Board: "Board",
        View: "Ansicht",
        CreateSalesOrder: "Verkaufsauftrag erstellen",
        CreatePurchaseOrder: "Bestellung erstellen",
        successfully: "erfolgreich",
        ManageAttachments: "Anhänge verwalten",
        Stockoutitemsimmediatelyaftersaving: "Artikel sofort nach dem Speichern auslagern.",
        Stockinitemsimmediatelyaftersavingthisorder: "Artikel sofort nach dem Speichern dieses Auftrags einlagern.",
        ViewAttachments: "Anhänge anzeigen",
        MemoAttachments: "Notiz & Anhänge",
        ReceivedDate: "Eingangsdatum",
        ShippedDate: "Versanddatum",
        OrderDate: "Bestelldatum",
        OrderDetails: "Bestelldetails",
        Subtotal: "Zwischensumme",
        OrderSummary: "Bestellübersicht",
        AddItem: "Artikel hinzufügen",
        NewSalesOrder: "Neuer Verkaufsauftrag",
        NewPurchaseOrder: "Neue Bestellung",
        Createandmanageyour: "Erstellen und verwalten Sie Ihre",
        orders: "Bestellungen",
        Removeitem: "Artikel entfernen",
        UnitPrice: "Stückpreis",
        PurchaseOrder: "Bestellung",
        SalesOrder: "Verkaufsauftrag",
        PurchaseInvoice: "Eingangsrechnung",
        SalesInvoice: "Ausgangsrechnung",
        PurchaseOrdernotfound: "Bestellung nicht gefunden",
        Approve: "Genehmigen",
        MarkasShipped: "Als versandt markieren",
        MarkasReceived: "Als empfangen markieren",
        Marking: "Markiere...",
        PartiallyShip: "Teilversand",
        PartiallyReceive: "Teilempfang",
        Deleting: "Lösche...",
        Transaction: "Transaktion",
        Details: "Details",
        Item: "Artikel",
        Received: "Empfangen",
        Shipped: "Versandt",
        Ordered: "Bestellt",
        units: "Einheiten",
        Overalldiscount: "Gesamtrabatt",
        Transactions: "Transaktionen",
        Notransactionsfound: "Keine Transaktionen gefunden",
        OrderedQty: "Bestellte Menge",
        Totalqty: "Gesamtmenge",
        StockingOut: "Auslagern...",
        StockingIn: "Einlagern...",
        thiorderUpdateStuau: "diese Bestellung? Diese Aktion aktualisiert den Status.",
        TransactionDetails: "Transaktionsdetails",
        Fetchingtransactiondetails: "Lade Transaktionsdetails...",
        Nodetailsfoundforthistransaction: "Keine Details für diese Transaktion gefunden.",
        TotalBreakDown: "Gesamtaufschlüsselung",
        ChangeAmount: "Änderungsbetrag",
        Attachments: "Anhänge",
        PoNumber: "Bestellnummer",
        SoNumber: "Verkaufsauftragsnummer",
        partner: "Partner",
        EditPurchase: "Einkauf bearbeiten",
        EditSales: "Verkauf bearbeiten",
        PurchaseOrderDetails: "Bestelldetails",
        SalesOrderDetails: "Verkaufsauftragsdetails",
        OrderType: "Auftragsart",
        SelectOrderType: "Auftragsart auswählen",
        OrderTypePrepaid: "Prepaid",
        OrderTypeCOD: "Nachnahme",
        OrderTypePayLater: "Später bezahlen",
        OrderTypePartialPayment: "Teilzahlung",
        OrderTypeSubscription: "Abonnement",
        viewAvailabilty: 'Verfügbarkeit anzeigen',
        NotReceived: "Nicht erhalten",
        NotShipped: "Nicht versendet",
        PartiallyReceived: "Teilweise erhalten",
        PartiallyShipped: "Teilweise versendet",
    },
    PriceReference: {
        HighPrice: "Höchstpreis",
        LowPrice: "Niedrigster Preis",
        LastPrice: "Letzter Preis",
        LastPurchasePrice: "Letzter Einkaufspreis",
        Nopricerecordsfound: "Keine Preisaufzeichnungen gefunden",
        BuyingPriceReference: "Einkaufspreis-Referenz",
        SellingPriceReference: "Verkaufspreis-Referenz",
        Viewstockinpricesfortheselectedvendorandproduct: "Lager-Einstandspreise für den ausgewählten Lieferanten und Artikel anzeigen",
        Viewstockoutpricesfortheselectedcustomerandproduct: "Lager-Ausstandspreise für den ausgewählten Kunden und Artikel anzeigen"
    },
    SubscriptionLocale: {
        premiumPlan: "Premium-Plan",
        heading: "Treffe Geschäftsentscheidungen",
        headingHighlight: "Auf Basis von Daten",
        subtitle: "Schalte die volle Kraft deiner Business-Analytics frei — ohne Limits, ohne Kompromisse.",
        choosePlan: "Wähle deinen Plan",
        monthly: "Monatlich",
        annual: "Jährlich",
        oneTime: "Einmalig (Monatlich)",
        perMonth: "pro Monat",
        perYear: "pro Jahr",
        bestValue: "Bester Wert",
        continueWith: "Weiter mit",
        perMonthShort: "Mon.",
        perYearShort: "Jahr",
        troubleWithSubscription: "Probleme mit dem Abonnement?",
        contactUs: "Kontaktiere uns",
        paymentNotReady: "Zahlung nicht bereit",
        checkoutError: "CHECKOUT-FEHLER",
        pricePreviewError: "PREISVORSCHAU-FEHLER",
        subNotAvailable: "Abonnement nicht verfügbar",
        subNotAvailableDesc: "Web-Abonnements sind derzeit in Ihrem Land nicht verfügbar. Bitte abonnieren Sie über unsere mobile App oder kontaktieren Sie uns direkt für Hilfe."
    },
    SubscriptionLocale2: {
        GoPro: "Go Pro",
        Makesmarterdecisionsbackedbyrealbusinessdata: "Treffen Sie intelligentere Entscheidungen, gestützt auf echte Geschäftsdaten",
        ExploreProPlans: "Pro-Pläne entdecken"
    },
    emptyWarehouseState: {
        tips: [
            "Sie können mehrere Lager für verschiedene physische Standorte haben",
            "Jedes Produkt trackt den Bestand pro Lager unabhängig",
            'Verwenden Sie "Lager transferieren", um Bestand zwischen Standorten zu bewegen'
        ],
        NoWarehousesConfigured: "Keine Lager konfiguriert",
        desc: "Beginnen Sie mit dem Hinzufügen Ihrer Lager (falls Sie mehr als eines haben), dann fügen Sie Produkte hinzu und erfassen Sie Bestandsbewegungen.",
        WarehouseSetupTips: "Lager-Einrichtungstipps",
        Noproductselected: "Kein Produkt ausgewählt",
        Selectaproductfromthelefttoviewlowstockdetails: "Wählen Sie ein Produkt von links aus, um Details zum niedrigen Bestand anzuzeigen.",
        Chooseaproductfromthelist: "Wählen Sie ein Produkt aus der Liste",
        SelectProduct: "Produkt auswählen",
        SetQuantity: "Menge festlegen",
        Showing: "Anzeige",
        products: "Produkte",
        Continue: "Fortfahren",
        SaveSafetyStock: "Sicherheitsbestand speichern",
        SafetyStockSaved: "Sicherheitsbestand gespeichert!",
        hasbeensetto: "wurde gesetzt auf",
        AddAnother: "Weiteres hinzufügen",
        Chooseaproduct: "Produkt auswählen",
        Step: "Schritt",
        of: "von",
        Setsafetyquantity: "Sicherheitsmenge festlegen",
        Complete: "Abgeschlossen",
        SafetyStockQuantity: "Sicherheitsbestandsmenge",
        Minimumunitsdropsbelowthisnumber: "Mindestmenge, die immer im Lager gehalten werden soll. Eine Benachrichtigung wird ausgelöst, wenn der Bestand unter diese Zahl fällt.",
        NewSafetyStock: "Neuer Sicherheitsbestand",
        SafetyNow: "Sicherheit jetzt",
        SettingTo: "Wird gesetzt auf",
        Change: "Ändern",
        sell: "verkaufen",
        cost: "Kosten",
        BulUD: "Massen-Upload/Löschen"
    },
    SimplyLoginUI: {
        sslEncryption: "256-Bit SSL-Verschlüsselung",
        dataPrivate: "Ihre Daten sind 100% privat",
        worksOnDevices: "Funktioniert auf Android & iPhone",
        realTimeSync: "Echtzeit-Synchronisation auf allen Geräten",
        cloudBackup: "Automatische Cloud-Sicherung",
        availableOn: "Verfügbar auf Web, Android & iOS",
        tagline: "Ihr Inventar,",
        taglineEm: "wunderschön einfach.",
        subtitle: "Melden Sie sich an, um Lagerbestände zu verwalten, Verkäufe zu verfolgen und Ihr Geschäft am Laufen zu halten — alles an einem Ort.",
        feature1Title: "Echtzeit-Bestandsverfolgung",
        feature1Desc: "Wissen Sie genau, was in jedem Lager ist — immer aktuell.",
        feature2Title: "Verkaufs- & Einkaufsaufträge",
        feature2Desc: "Erstellen Sie Rechnungen, verwalten Sie Lieferanten und verfolgen Sie jede Transaktion.",
        feature3Title: "Intelligente Berichte",
        feature3Desc: "Finanz-, Bestands- und Tagesbewegungsberichte auf einen Blick.",
        feature4Title: "Echtzeit-Synchronisation auf allen Geräten",
        feature4Desc: "Änderungen am Handy erscheinen sofort im Web — und umgekehrt.",
        rating1: "Bewertet mit",
        rating2: "4.9/5",
        rating3: "von 10.000 Großhandelsunternehmen",
        brandName: "Simply",
        greeting: "Hallo wieder! 👋",
        noPasswordNeeded: "Melden Sie sich an, um auf Ihr Inventar zuzugreifen — Android, iPhone & Web, alles synchron.",
        badge1: "Bestandsverwaltung",
        badge2: "Verkaufsverfolgung",
        badge3: "Berichte",
        trustEncryptedTitle: "Verschlüsselt",
        trustEncryptedSub: "256-Bit SSL",
        trustPrivateTitle: "Privat",
        trustPrivateSub: "Nur Ihre Daten",
        trustBackedTitle: "Gesichert",
        trustBackedSub: "Täglich automatisch",
        availableOnLabel: "VERFÜGBAR AUF",
        platformAndroid: "Android",
        platformIphone: "iPhone",
        platformWeb: "Web",
        syncBadge: "Alle Geräte synchronisieren sich in Echtzeit",
        securityNote: "100% sicher.",
        securityDesc: "Bankenstandard-Verschlüsselung schützt alle Ihre Daten. Wir lesen nur Ihren Namen und Ihre E-Mail — sonst nichts, niemals.",
        signingIn: "Sie werden angemeldet…",
        termsPrefix: "Mit der Anmeldung stimmen Sie Simplys",
        privacyPolicy: "Datenschutzrichtlinie",
        and: "und",
        termsOfService: "Nutzungsbedingungen",
        google: "Mit Google anmelden"
    },
    BatchLocal: {
        BatchName: "Chargenname",
        EnterBatchName: "Chargennamen eingeben",
        EnterNotes: "Notizen eingeben",
        ExpiredDate: "Ablaufdatum",
        Selectexpireddate: "Ablaufdatum auswählen",
        BatchStatus: "Chargenstatus",
        CreatedDate: "Erstellungsdatum",
        Areyousureyouwanttodeletethisbatch: "Möchten Sie diese Charge wirklich löschen?",
        Youhavencreatedanybatchforthisproduct: "Sie haben für dieses Produkt noch keine Charge erstellt.",
        Createyourfirstbatchtostarttrackingtockbylotexpiry: "Erstellen Sie Ihre erste Charge, um den Bestand nach Lot und Ablaufdatum zu verfolgen.",
        Nobatchesyet: "Noch keine Chargen",
        Whatisbatchmanagement: "Was ist Chargenmanagement?",
        Howithelpsyourbusiness: "Wie es Ihrem Unternehmen hilft",
        Trackbylotnumber: "Nach Lot-Nummer verfolgen",
        Trackbylotnumberdesc: "Gruppieren Sie den Bestand nach Hersteller-Charge, damit Sie immer wissen, aus welchem Lot eine Einheit stammt.",
        Expirydatecontrol: "Ablaufdatum-Kontrolle",
        Expirydatecontroldesc: "Erhalten Sie Benachrichtigungen bevor der Bestand abläuft. Verkaufen Sie ältere Chargen zuerst und reduzieren Sie Abfall automatisch.",
        Fulltraceability: "Vollständige Rückverfolgbarkeit",
        Fulltraceabilitydesc: "Sehen Sie genau, welche Charge in jeder Transaktion verwendet wurde — ideal für Audits und Rückrufe.",
        Supplierwisestock: "Bestand nach Lieferant",
        Supplierwisestockdesc: "Trennen Sie Bestände von verschiedenen Lieferanten auch für dasselbe Produkt. Vergleichen Sie Qualität Charge für Charge.",
        Createyourfirstbatchbutton: "Erste Charge erstellen",
        Nomatchesfound: "Keine Übereinstimmungen gefunden",
        NomatchesfounddescBefore: "Wir konnten keine Chargen finden, die zu ",
        NomatchesfounddescAfter: " passen.",
        Clearsearch: "Suche löschen",
        Nohistoryfoundthisbatch: "Keine Historie für diese Charge gefunden",
        ComprehensiveDetails: "Umfassende Details",
        History: "Historie",
        InBatch: "In der Charge",
        Noproductfoundinthisbatch: "Kein Produkt in dieser Charge gefunden",
        SelectBatch: "Charge auswählen",
        available: "verfügbar",
        Searchbatches: "Chargen suchen...",
        Expires: "Läuft ab",
        Nobatchesfound: "Keine Chargen gefunden",
        ManageBatches: "Chargen verwalten",
        Batchmanagement: "Chargenmanagement",
        Trackstockexpiry: "Bestand nach Charge & Ablaufdatum verfolgen",
        Turnoffbatchmanagement: "Chargenmanagement deaktivieren?",
        Yourgsafe: "Ihre vorhandenen Chargendaten bleiben sicher.",
        Reenableanytimefrom: "Jederzeit wieder aktivieren über",
        Otherstab: "Registerkarte „Sonstiges“",
        AddBatch: "Charge hinzufügen",
        Total: "Gesamt",
        AssignProduct: "Produkt zuweisen",
        EditProductAssignment: "Produktzuweisung bearbeiten",
        AssignProducttoBatch: "Produkt der Charge zuweisen",
        Updateproductconfiguration: "Produktkonfiguration aktualisieren",
        Step1of2: "Schritt 1 von 2",
        Step2of2: "Schritt 2 von 2",
        Selectvariantwarehouse: "Variante & Lager auswählen",
        SelectedProduct: "Ausgewähltes Produkt",
        AssignQuantity: "Menge zuweisen",
        BatchInfo: "Chargeninformationen",
        Wecouldnthisproductidentifier: "Wir konnten keine Chargen finden, die mit diesem Produkt-Identifikator verknüpft sind.",
        NoActiveBatches: "Keine aktiven Chargen",
        Endofresults: "Ende der Ergebnisse",
        Expiry: "Ablauf",
        BatchManagementDescription: "Verfolgen Sie den Bestand nach Chargennummer und Ablaufdatum. Gewährleistet die korrekte LIFO / FEFO-Reihenfolge bei jedem Warenausgang — keine manuelle Kommissionierung erforderlich.",
        Expiryalerts: "Ablaufwarnungen",
        Autonotifications: "Automatische Benachrichtigungen",
        LIFOsorting: "LIFO / FEFO-Sortierung",
        Smartstockflow: "Intelligenter Bestandsfluss",
        Perout: "Chargenbezogener Warenausgang",
        Precisiontracking: "Präzise Nachverfolgung",
        NeedsReview: "Überprüfung erforderlich",
        Pending: "Ausstehend",
        Rejected: "Abgelehnt",
        Approved: "Genehmigt",
        WaitingForApproval: "Warten auf Genehmigung",
        WaitingForApprovalDesc: "Ihr Eigentümer wird diesen Stapel in Kürze überprüfen und genehmigen.",
        BatchRejected: "Stapel abgelehnt",
        BatchRejectedDesc: "Ihr Eigentümer hat diesen Stapel abgelehnt.",
        Reason: "Grund",
        Approve: "Genehmigen",
        Reject: "Ablehnen",
        ConfirmApproveTitle: "Stapel genehmigen",
        ConfirmRejectTitle: "Stapel ablehnen",
        ConfirmApprovalAction: "Sind Sie sicher, dass Sie diesen Stapel {action} möchten? Diese Aktion aktualisiert den Status.",
        ReasonOptional: "Grund (Optional)",
        EnterReasonPlaceholder: "Geben Sie einen Grund für {action} ein (optional)",
        Processing: "Verarbeitung...",
        BatchActivatedSuccess: "Stapel erfolgreich aktiviert",
        BatchDeactivatedSuccess: "Stapel erfolgreich deaktiviert",
        BatchDeletedSuccess: "Stapel erfolgreich gelöscht",
        BatchApprovedSuccess: "Stapel erfolgreich genehmigt",
        BatchRejectedSuccess: "Stapel erfolgreich abgelehnt",
        SearchByBatchName: "Nach Stapelnamen suchen...",
        YesTurnOff: "Ja, ausschalten",
        KeepItOn: "Eingeschaltet lassen"
    },
    CategoryNewL: {
        TotalCategories: "Gesamtkategorien",
        lastaddedcategory: "Zuletzt hinzugefügte Kategorie",
        acrossalltypes: "über alle Typen",
        MostRecent: "Neueste",
        YesD: "Ja, löschen",
        AllAssociated: "Alle zugehörigen Produkte können betroffen sein"
    },
    OverDas: {
        movestockbetweenlocations: "Bestand verschieben",
        no_activity_yet: "Noch keine Aktivität",
        no_activity_sub: "Verkäufe, Einkäufe, Bestandsbewegungen und Retouren erscheinen hier in Echtzeit.",
        make_first_sale: "Ersten Verkauf tätigen",
        add_stock: "Bestand hinzufügen",
        all_stock_healthy: "Alle Bestandsmengen sind gesund",
        all_stock_healthy_sub: "Keine Artikel sind knapp. Legen Sie Mindestschwellen für Produkte fest, um hier Benachrichtigungen zu erhalten.",
        set_stock_thresholds: "Bestandsschwellen festlegen",
        no_warehouses_setup: "Keine Lager eingerichtet",
        no_warehouses_setup_sub: "Fügen Sie ein Lager hinzu, um zu verfolgen, wo Ihr Bestand gelagert ist und Standorte zu verwalten.",
        add_first_warehouse: "Erstes Lager hinzufügen",
        Customer: "Kunden",
        PurchasevsSales: "Einkauf vs Verkauf",
        Financialperformancechart: "Finanzielle Leistungsübersicht",
        QuickActions: "Schnellaktionen",
        Frequentlyused: "Häufig verwendet",
        Addinventory: "Inventar hinzufügen",
        Dispatchitems: "Artikel versenden",
        Addorder: "Bestellung hinzufügen",
        Newitem: "Neuer Artikel",
        Inventoryaccess: "Inventarzugriff",
        Itemsneedingreorder: "Artikel die nachbestellt werden müssen",
        Latesttransactions: "Letzte Transaktionen",
        Operationalsummary: "Betriebszusammenfassung",
        ViewAll: "Alle ansehen",
        Manage: "Verwalten",
        RecentActivity: "Letzte Aktivitäten",
        LowStockAlerts: "Niedriger Bestand Warnungen",
        Primary: "Primär",
        TotalWarehouses: "Gesamtlager"
    },
    SerialLocal: {
        ShowOrHideFields: "Felder ein- oder ausblenden",
        ShowOrHideFieldsDesc: "Tippen Sie unten auf ein Element, um es in die gedruckte Rechnung aufzunehmen oder daraus zu entfernen. Änderungen werden sofort übernommen.",
        Manufacturesettings: "Herstellungseinstellungen",
        Showbuyingprice: "Einkaufspreis / Produktkosten",
        Showadditionalcost: "Zusätzliche Kosten",
        Costbreakdown: "Kostenaufstellung",
        Unitcost: "Stückkosten",
        Rawmaterialstotal: "Gesamte Rohstoffe",
        Confirmentry: "Eingabe bestätigen",
        SaveSerials: "Seriennummern speichern",
        SerialNumber: "Seriennummer",
        selected: "ausgewählt",
        added: "hinzugefügt",
        Serialnumbers: "Seriennummern",
        ResetAll: "Alles zurücksetzen",
        Wecouldnfindthis: "Wir konnten keine verfügbaren Seriennummern für dieses Produkt finden.",
        Nounitsfound: "Keine Einheiten gefunden",
        Searchingserialnumbers: "Seriennummern werden gesucht...",
        Scanorenterstock: "Seriennummern scannen oder eingeben für neuen Bestand",
        Whataserialnumber: "Was ist eine Seriennummer?",
        Auniqueidentifieryourinventorylifecycle: "Ein eindeutiger Identifikator pro Einheit — ermöglicht die Nachverfolgung jedes einzelnen Artikels durch den gesamten Lagerlebenszyklus.",
        Trackedstockout: "Nachverfolgter Bestandsabgang",
        Chooseexactlyselected: "Wählen Sie genau aus, welche Seriennummern ausgehend sind. Es werden nur Seriennummern angezeigt, die für dieses Produkt eingelagert wurden — die Menge wird gesperrt, sobald Sie ausgewählt haben ",
        SelectSerialstoout: " - Seriennummern zum Auslagern auswählen",
        Thisinvoicegeneratedusingwwwsimplstockco: "Diese Rechnung wurde mit www.simplstock.co erstellt",
        AuthorizedSignature: "Autorisierte Unterschrift",
        Invoicesettings: "Rechnungseinstellungen",
        Draw: "Zeichnen",
        Taptoselectordeselectitems: "Tippen zum Auswählen oder Abwählen von Artikeln",
        Thissignaturewillbeadded: "Diese Unterschrift wird unten auf Ihrer gedruckten Rechnung hinzugefügt.",
        SignatureOptions: "Unterschriftsoptionen",
        Upload: "Hochladen",
        DrawSignature: "Unterschrift zeichnen",
        UploadSignature: "Unterschrift hochladen",
        Clear: "Löschen",
        ShowStaffName: "Mitarbeiternamen",
        ShowSKU: "SKU",
        ShowBusinessName: "Firmennamen",
        ShowProductName: "Produktnamen",
        ShowBusinessPhoneNumber: "Telefonnummer",
        ShowBusinessEmail: "E-Mail",
        ShowBusinessAddress: "Adresse",
        ShowProductImage: "Produktbild",
        ShowPaymentDetails: "Zahlungsdetails",
        ShowCategory: "Kategorie",
        ShowVariant: "Variante",
        ShowWarehouse: "Lager",
        ShowAttributes: "Attribute",
        ShowQuantity: "Menge",
        ShowDiscount: "Rabatt",
        ShowTax: "Steuer",
        ShowPrice: "Preis",
        ShowTotalPrice: "Gesamtpreis des Produkts",
        ShowExpenses: "Ausgaben",
        ShowSignature: "Unterschrift ",
        ShowNote: "Notiz",
        showAttachment: "Anhang",
        ShowSerialNumber: "Seriennummer",
        Invoicesettingsapplied: "Rechnungseinstellungen angewendet. Überprüfen Sie die Rechnung auf Änderungen.",
        EnterSerialNumber: "Seriennummer eingeben",
    },
    Bin: {
        Bin: "Bin",
        Add: "Hinzufügen",
        NoBinsAddedYet: "Noch keine Bins hinzugefügt",
        BinLocationsHelp: "Bin-Standorte helfen Ihnen, den Bestand an der genauen Position im Lager zu verfolgen — kein Suchen mehr nötig.",
        NameThemByPosition: "Benennen Sie sie nach Position:",
        AddBinLocation: "Bin-Standort hinzufügen",
        BinLocations: "Bin-Standorte",
        BinNameRequired: "Bin-Name ist erforderlich",
        EditBin: "Bin bearbeiten",
        AddBin: "Bin hinzufügen",
        EnterBinName: "Bin-Name",
        EnterBinNamePlaceholder: "Bin-Namen eingeben",
        BinStatus: "Bin-Status",
        BinNotes: "Notizen",
        EnterBinNotesPlaceholder: "Fügen Sie Notizen hinzu...",
        ViewInventory: "Inventar ansehen",
        Inventory: "Inventar",
        TrymatchingadifferentSKUname: "Versuchen Sie es mit einem anderen SKU oder Namen.",
        Thisbinlocationcurrentlyempty: "Dieser Bin-Standort ist derzeit leer.",
        Loadingbins: "Bins werden geladen...",
        bins: "Bins",
        ManageBin: "Behälter verwalten",
        Print: "Drucken",
        SBin: "Quell-Bin",
        DBin: "Ziel-Bin"
    },
    WarehouseExcel: {
        title: "Lagerhäuser & Bin-Standorte hochladen",
        description: "Folgen Sie den Schritten unten, um Lagerhäuser mit ihren Bin-Standorten per Excel-Datei massenhaft anzulegen.",
        bulkUploadGuide: "Massen-Upload-Anleitung",
        step1: "Schritt 1",
        downloadTemplate: "Excel-Vorlage herunterladen",
        downloadTemplateDesc: "Laden Sie die offizielle Vorlage mit allen erforderlichen Spaltenüberschriften herunter. Benennen Sie keine Spalten um oder löschen Sie sie.",
        downloadTemplateBtn: "Vorlage herunterladen",
        step2: "Schritt 2",
        fillExcelFile: "Excel-Datei ausfüllen",
        fillExcelDesc: "Jede Zeile steht für ein Lagerhaus. Füllen Sie alle Spalten aus — für Bin-Standorte geben Sie alle Bin-Namen kommagetrennt in die Spalte <code>Bin Names</code> ein.",
        step3: "Schritt 3",
        thingsToKeepInMind: "Wichtige Hinweise",
        rulesDesc: "Stellen Sie vor dem Hochladen sicher, dass Ihre Datei diesen Regeln entspricht.",
        step4: "Schritt 4",
        uploadYourFile: "Datei hochladen",
        uploadDesc: "Nach dem Ausfüllen laden Sie die Datei unten hoch. Das System erstellt alle Lagerhäuser und Bin-Standorte automatisch.",
        rules: ["Nur eine Zeile pro Lagerhaus", "Bin-Namen kommagetrennt in einer Zelle", "Spaltenüberschriften nicht umbenennen", "Doppelte Bin-Namen pro Lagerhaus werden übersprungen", "Telefonnummer mit Ländercode", "Nur .xlsx oder .xls Dateien erlaubt"],
        dropFileHere: "Excel-Datei hier ablegen",
        supports: "Unterstützt .xlsx und .xls — max. 10 MB",
        chooseFileUpload: "Datei auswählen & hochladen",
        parsing: "Datei wird analysiert...",
        invalidFileType: "Ungültiger Dateityp. Bitte eine Excel-Datei hochladen.",
        noData: "Keine Daten in der Excel-Datei gefunden",
        failedToRead: "Excel-Datei konnte nicht gelesen werden",
        unableToRead: "Datei konnte nicht gelesen werden.",
        reviewTitle: "Lagerhaus-Daten prüfen",
        reviewSubtitle: "Letzte Überprüfung vor dem Import.",
        changeFile: "Datei ändern",
        rowsFound: "Zeilen in der Datei gefunden",
        cancel: "Abbrechen",
        finalizeImport: "Abschließen & Importieren",
        importing: "Importiere...",
        success: "Erfolg",
        allWarehouseUploadedSuccess: "Alle Lagerhäuser erfolgreich hochgeladen",
        failed: "Fehlgeschlagen",
        bulkUploadFailed: "Massen-Upload fehlgeschlagen",
        error: "Fehler",
        binNamesNote: "In der Spalte <strong>Bin Names</strong> alle Bin-Standorte in einer Zelle kommagetrennt eingeben — z.B. A1, A2, B1, RACK-01.",
        headers: { warehouseName: "Lagerhaus-Name", email: "E-Mail", phoneNumber: "Telefonnummer", location: "Standort", binNames: "Bin-Namen" },
    },
    VariantTemplate: {
        VariantTemplates: "Varianten-Vorlagen",
        Managereusablevariantpatterns: "Wiederverwendbare Variantenmuster verwalten",
        BinTransferHistory: "Bin-Transfer-Historie",
        Trackmovementsacrossbins: "Bewegungen zwischen Bins nachverfolgen",
        SerialNumberHistory: "Seriennummern-Historie",
        Trackproductserialnumberactivity: "Aktivität der Produk-Seriennummern verfolgen",
        Period: "Zeitraum",
        Nohistoryfound: "Keine Historie gefunden",
        Searchserialnumbers: "Seriennummern suchen...",
        SerialNumbersHistory: "Seriennummern-Historie",
        Serialnumberhistoryglance: "Seriennummern-Historie auf einen Blick.",
        Noserialnumbersfound: "Keine Seriennummern gefunden",
        Noactivityhistoryfound: "Keine Aktivitätshistorie gefunden",
        Statussetto: "Status gesetzt auf",
        Timeline: "Zeitachse",
        Managereusableproductvariantpatterns: "Wiederverwendbare Produktvarianten-Muster verwalten.",
        DeleteTemplate: "Vorlage löschen",
        Areyousureyouwanttemplate: "Möchten Sie diese Vorlage wirklich löschen?",
        CreateNewTemplate: "Neue Vorlage erstellen",
        CreateTemplate: "Vorlage erstellen",
        EditTemplate: "Vorlage bearbeiten",
        UnlimitedTemplates: "Unbegrenzt viele Vorlagen",
        CreateAsManyTemplates: "Erstellen Sie so viele Vorlagen wie Sie brauchen — Kleidung, Schuhe, Elektronik und mehr.",
        PickWhileAddingProduct: "Beim Hinzufügen eines Produkts auswählen",
        OpenTemplateLibrary: "Öffnen Sie Ihre Vorlagen-Bibliothek und wählen Sie Variantennamen in Sekunden aus.",
        MixFromMultipleTemplates: "Aus mehreren Vorlagen mischen",
        SelectFromMultipleTemplates: "Wählen Sie Variantennamen aus mehreren Vorlagen für ein Produkt — volle Flexibilität.",
        EditAnytime: "Jederzeit bearbeiten",
        RenameTemplatesAnytime: "Vorlagen umbenennen, Variantennamen hinzufügen oder entfernen, wann immer sich Ihr Katalog geändert hat.",
        StayConsistent: "Konsistent bleiben",
        SameVariantNamesAcrossAll: "Gleiche Variantennamen bei allen Produkten. Keine Tippfehler, keine Duplikate, kein Raten.",
        BuildOnceUseEverywhere: "Einmal erstellen, überall verwenden",
        StopReEnteringVariantNames: "Hören Sie auf, dieselben Variantennamen bei jedem Produkt neu einzugeben. Erstellen Sie eine Vorlage, weisen Sie Variantennamen zu und verwenden Sie sie sofort wieder.",
        Updateexistingvariantcombinations: "Bestehende Variantenkombinationen aktualisieren",
        Definenewvariantcombinations: "Neue Variantenkombinationen definieren",
        TemplateName: "Vorlagenname",
        AddVariantOptions: "Variantenoptionen hinzufügen",
        SmallMedium: "z.B. Klein, Mittel...",
        VariantsList: "Variantenliste",
        Nooptionsaddedyet: "Noch keine Optionen hinzugefügt",
        SaveTemplate: "Vorlage speichern",
        egSizesColorsetc: "z.B. T-Shirt Größen, Farben, etc.",
        Pleaseentertemplatename: "Bitte geben Sie einen Vorlagennamen ein",
        Pleaseaddatleastonevariantoption: "Bitte fügen Sie mindestens eine Variantenoption hinzu",
        Templateupdatedsuccessfully: "Vorlage erfolgreich aktualisiert",
        Templatecreatedsuccessfully: "Vorlage erfolgreich erstellt",
        Failedtosavetemplate: "Fehler beim Speichern der Vorlage",
        Transfer: "Übertragen",
        Editassignment: "Zuweisung bearbeiten",
        Updateproductdetailsinbin: "Produktdetails im Bin aktualisieren",
        Editinginbin: "Wird im Bin bearbeitet",
        ConfirmUpdate: "Aktualisierung bestätigen",
        ConfirmAssign: "Zuweisung bestätigen",
        Assignanotherproduct: "Ein weiteres Produkt zuweisen",
        TransferBin: "Bin übertragen",
        SourceBin: "Quell-Bin",
        DestinationBin: "Ziel-Bin",
        SelectSourceBin: "Quell-Bin auswählen",
        SelectDestinationBin: "Ziel-Bin auswählen",
        Unit: "Einheit",
        ManageVariant: "Variante verwalten",
        CreateSKUvariationsyourproduct: "SKU-Variationen für Ihr Produkt erstellen",
        Assigningvariationsto: "Variationen zuweisen an",
        Novariantsaddedyet: "Noch keine Varianten hinzugefügt",
        AddedVariants: "Hinzugefügte Varianten",
        AddVariantsfromTemplate: "Varianten aus Vorlage hinzufügen",
        Pickatemplateandselectvariantnames: "Vorlage auswählen und Variantennamen auswählen",
        ChooseaTemplate: "Vorlage auswählen",
        Selectvariantnamestoadd: "Variantennamen zum Hinzufügen auswählen",
        SelectatemplatetopickvariantnamesfroYoucanaddfrommultiple: "Wählen Sie eine Vorlage aus, um Variantennamen zu übernehmen. Sie können aus mehreren Vorlagen hinzufügen.",
        Loadingtemplates: "Vorlagen werden geladen...",
        Backtotemplates: "Zurück zu den Vorlagen",
        Selectallindividualadd: "Alle oder einzelne Variantennamen zum Hinzufügen auswählen.",
        VariantNames: "Variantennamen",
        MediaDescription: "Medien & Beschreibung",
        Addattachmentsandproductnotes: "Anhänge und Produktnotizen hinzufügen",
        ProductMedia: "Produktmedien"
    },
    AddProductGuide: {
        title: "Anfangsbestand nach dem Speichern hinzufügen",
        description: "Produkte haben hier kein Mengenfeld. Nach dem Speichern verwenden Sie 'Bestand einbuchen', um Ihren Eröffnungsbestand zu erfassen — mit voller Kontrolle über Standort und Nachverfolgung.",
        steps: {
            quantity: { title: "Menge", sub: "Eröffnungsbestand festlegen" },
            binLocation: { title: "Bin-Standort", sub: "Gang, Regal, Fach — z.B. A-01-03" },
            serialNumbers: { title: "Seriennummern", sub: "Jede Einheit einzeln nachverfolgen" },
            warehouse: { title: "Lager", sub: "In welchem Lager es gelagert ist" },
            batchExpiry: { title: "Charge / Ablaufdatum", sub: "Bestand nach Chargennummer gruppieren" }
        },
        actions: { close: "Schließen" }
    },
    Remainingtranferitems: {
        NoTransferOrdersFound: "Keine Transferaufträge gefunden",
        Itemshistory: "Artikel, die Sie zwischen Lagern transferieren, werden hier zur Nachverfolgung und Historie angezeigt.",
        CreateTransfer: "Transfer erstellen"
    },



    ManufactureLocal: {
        TaponproducttoManufacture: "Produkt zum Herstellen antippen",
        Selectproductfrombelow: "Produkt aus der Liste auswählen",
        SetupANewProduct: "Neues Produkt einrichten",
        DefineAProductAdditsrawmaterial: "Produkt definieren & Rohmaterialien hinzufügen",
        ManufacturingSetup: "Fertigungseinrichtung",
        Pickproducttodefineitsproductiondetails: "Produkt auswählen, um Produktionsdetails festzulegen",
        ConfigureManufacturing: "Fertigung konfigurieren",
        SelectRawMaterial: "Rohmaterial auswählen",
        NoRawMaterials: "Keine Rohmaterialien",
        Definecomponentsneededtoproduct: "Komponenten definieren, die zur Herstellung dieses Produkts benötigt werden.",
        NoAdditionalCosts: "Keine zusätzlichen Kosten",
        Addlaboroverheadlogisticalcharges: "Arbeits-, Gemein- oder Logistikkosten hinzufügen.",
        AddAdditionalCost: "Zusatzkosten hinzufügen",
        AddCost: "Kosten hinzufügen",
        TotalPrice: "Gesamtpreis",
        SelectCharges: "Gebühren auswählen",
        EnterEstimatedCost: "Geschätzte Kosten eingeben",
        QtyRequried: "Benötigte Menge",
        Manufacturing: "Fertigung",
        Outputfinishedgoodsdestination: "Ziel der Fertigwaren",
        Manufacturingquantity: "Fertigungsmenge",
        Storefinishedgoodsat: "Fertigwaren lagern bei",
        Rawmaterials: "Rohmaterialien",
        StockSelection: "Lagerauswahl",
        AdditionalCosts: "Zusätzliche Kosten",
        Quantityconsume: "Zu verbrauchende Menge",
        Totalmanufacturingcost: "Gesamte Fertigungskosten",
        Sumofrawmaterialcosts: "Summe aller Rohmaterialkosten",
        CustomManufacturingCharge: "Benutzerdefinierte Fertigungsgebühr",
        Addextralikelaboroverheadrepairs: "Zusatzkosten wie Arbeit, Gemeinkosten oder Reparaturen hinzufügen.",
        CalculatedTotal: "Berechnetes Gesamt",
        AddRawMaterial: "Rohmaterial hinzufügen",
        ConfigureRawMaterial: "Rohmaterial konfigurieren",
        Thisoutputunit: "Dies ist die Basismenge pro Ausgabeeinheit.",
        ChangeProduct: "Produkt wechseln",
        AddtoList: "Zur Liste hinzufügen",
        ManufacturedSuccessfully: "Erfolgreich hergestellt",
        Manufacture: "Fertigung",
        BinNameRequired: "Bin-Name ist erforderlich",
        EditBin: "Bin bearbeiten",
        AddBin: "Bin hinzufügen",
        EnterBinName: "Bin-Name",
        EnterBinNamePlaceholder: "Bin-Namen eingeben",
        BinStatus: "Bin-Status",
        BinNotes: "Notizen",
        EnterBinNotesPlaceholder: "Fügen Sie Notizen hinzu...",
        ViewInventory: "Inventar ansehen",
        Inventory: "Inventar",
        TrymatchingadifferentSKUname: "Versuchen Sie es mit einem anderen SKU oder Namen.",
        Thisbinlocationcurrentlyempty: "Dieser Bin-Standort ist derzeit leer.",
        Loadingbins: "Bins werden geladen...",
        bins: "Bins",
        ManageBin: "Behälter verwalten",
        Print: "Drucken",
        SBin: "Quell-Bin",
        DBin: "Ziel-Bin",
        EditDeleteHistory: "Bearbeiten/Löschen Verlauf",
        ManageOrder: "Auftrag verwalten",
        ManageBatch: "Charge verwalten",
        Paymentnotavailablehere: "Zahlung hier nicht verfügbar",
        Thisrecordisanorderorderitself: "Dieser Datensatz stammt aus einem Auftrag. Die Zahlung kann nur vom Auftrag selbst erfasst werden.",
        Torecorpaymenttheorderthethere: "Um eine Zahlung zu erfassen, gehen Sie zum verknüpften Auftrag und verwenden Sie dort die Option <b>Zahlung erfassen</b>.",
        GotoOrder: "Zum Auftrag"
    },
    CustomerExcel: {
        title: "Kunden hochladen",
        description: "Folgen Sie den unten stehenden Schritten, um Kunden in großen Mengen mit einer Excel-Datei zu erstellen.",
        bulkUploadGuide: "Leitfaden für Massen-Upload",
        step1: "Schritt 1",
        downloadTemplate: "Excel-Vorlage herunterladen",
        downloadTemplateDesc: "Holen Sie sich die offizielle Vorlage mit allen erforderlichen Spaltenüberschriften.",
        downloadTemplateBtn: "Vorlage herunterladen",
        step2: "Schritt 2",
        fillExcelFile: "Excel-Datei ausfüllen",
        fillExcelDesc: "Jede Zeile stellt einen Kunden dar. Füllen Sie alle Spalten nach Bedarf aus.",
        step3: "Schritt 3",
        thingsToKeepInMind: "Dinge, die zu beachten sind",
        rulesDesc: "Stellen Sie vor dem Hochladen sicher, dass Ihre Datei diesen Regeln folgt, um Fehler zu vermeiden.",
        step4: "Schritt 4",
        uploadYourFile: "Laden Sie Ihre Datei hoch",
        uploadDesc: "Nach dem Ausfüllen laden Sie die Datei unten hoch. Das System erstellt automatisch alle Kunden.",
        rules: [
            "Nur eine Zeile pro Kunde",
            "Spaltenüberschriften nicht umbenennen",
            "Kontaktnummer mit Ländercode",
            "Nur .xlsx oder .xls Dateien werden akzeptiert"
        ],
        dropFileHere: "Legen Sie Ihre Excel-Datei hier ab",
        supports: "Unterstützt .xlsx und .xls — maximal 10 MB",
        chooseFileUpload: "Datei auswählen & hochladen",
        parsing: "Datei wird analysiert...",
        invalidFileType: "Ungültiger Dateityp. Bitte laden Sie eine Excel-Datei hoch.",
        noData: "Keine Daten in Excel gefunden",
        failedToRead: "Excel-Datei konnte nicht gelesen werden",
        unableToRead: "Datei kann nicht gelesen werden.",
        reviewTitle: "Kundendaten überprüfen",
        reviewSubtitle: "Letzte Prüfung vor dem Import in Ihr Unternehmen.",
        changeFile: "Datei ändern",
        rowsFound: "Zeilen in der Datei gefunden",
        cancel: "Abbrechen",
        finalizeImport: "Abschließen & Importieren",
        importing: "Importieren...",
        success: "Erfolg",
        allCustomerUploadedSuccess: "Alle Kunden erfolgreich hochgeladen",
        failed: "Fehlgeschlagen",
        bulkUploadFailed: "Massen-Upload fehlgeschlagen",
        error: "Fehler",
        headers: {
            customerName: "Kundenname",
            phoneNumber: "Kontakt",
            address: "Adresse",
            note: "Hinweis"
        }
    },
    SupplierExcel: {
        title: "Lieferanten hochladen",
        description: "Folgen Sie den unten stehenden Schritten, um Lieferanten in großen Mengen mit einer Excel-Datei zu erstellen.",
        bulkUploadGuide: "Leitfaden für Massen-Upload",
        step1: "Schritt 1",
        downloadTemplate: "Excel-Vorlage herunterladen",
        downloadTemplateDesc: "Holen Sie sich die offizielle Vorlage mit allen erforderlichen Spaltenüberschriften.",
        downloadTemplateBtn: "Vorlage herunterladen",
        step2: "Schritt 2",
        fillExcelFile: "Excel-Datei ausfüllen",
        fillExcelDesc: "Jede Zeile stellt einen Lieferanten dar. Füllen Sie alle Spalten nach Bedarf aus.",
        step3: "Schritt 3",
        thingsToKeepInMind: "Dinge, die zu beachten sind",
        rulesDesc: "Stellen Sie vor dem Hochladen sicher, dass Ihre Datei diesen Regeln folgt, um Fehler zu vermeiden.",
        step4: "Schritt 4",
        uploadYourFile: "Laden Sie Ihre Datei hoch",
        uploadDesc: "Nach dem Ausfüllen laden Sie die Datei unten hoch. Das System erstellt automatisch alle Lieferanten.",
        rules: [
            "Nur eine Zeile pro Lieferant",
            "Spaltenüberschriften nicht umbenennen",
            "Kontaktnummer mit Ländercode",
            "Nur .xlsx oder .xls Dateien werden akzeptiert"
        ],
        dropFileHere: "Legen Sie Ihre Excel-Datei hier ab",
        supports: "Unterstützt .xlsx und .xls — maximal 10 MB",
        chooseFileUpload: "Datei auswählen & hochladen",
        parsing: "Datei wird analysiert...",
        invalidFileType: "Ungültiger Dateityp. Bitte laden Sie eine Excel-Datei hoch.",
        noData: "Keine Daten in Excel gefunden",
        failedToRead: "Excel-Datei konnte nicht gelesen werden",
        unableToRead: "Datei kann nicht gelesen werden.",
        reviewTitle: "Lieferantendaten überprüfen",
        reviewSubtitle: "Letzte Prüfung vor dem Import in Ihr Unternehmen.",
        changeFile: "Datei ändern",
        rowsFound: "Zeilen in der Datei gefunden",
        cancel: "Abbrechen",
        finalizeImport: "Abschließen & Importieren",
        importing: "Importieren...",
        success: "Erfolg",
        allSupplierUploadedSuccess: "Alle Lieferanten erfolgreich hochgeladen",
        failed: "Fehlgeschlagen",
        bulkUploadFailed: "Massen-Upload fehlgeschlagen",
        error: "Fehler",
        headers: {
            supplierName: "Lieferantenname",
            phoneNumber: "Kontakt",
            bankName: "Bankname",
            accountHolderName: "Kontoinhaber",
            accountNumber: "Kontonummer",
            note: "Hinweis"
        }
    },
    ReplaceReturnLocal: {
        BuyingPrice: "Einkaufspreis",
        SellingPrice: "Verkaufspreis",
        ReplacedWith: "Ersetzt durch",
        Noreplacementhistoryfound: "Kein Ersetzungsverlauf gefunden",
        Noreturnhistoryfound: "Kein Rücksendeprotokoll gefunden",
        Productbeingreturned: "Zurückzusendender Artikel",
        Required: "Erforderlich",
        Selectreturnedproduct: "Zurückzusendenden Artikel auswählen",
        Searchnamescanbarcode: "Nach Name, SKU suchen oder Barcode scannen",
        Browse: "Durchsuchen",
        Stockhandling: "Bestandsaufnahme-Handhabung",
        Stockinreturnedproduct: "Zurückgesendeten Artikel einlagern",
        Ontoinventory: "Ein — Artikel wird dem Bestand wieder hinzugefügt",
        Offreturnedonly: "Aus — Artikel wird nur als zurückgesendet protokolliert",
        Usedrestock: "Wird zur Gewinnkorrektur bei der Wiedereinlagerung verwendet",
        Willaddedbackconfirmation: "Wird bei Bestätigung dem Bestand wieder hinzugefügt",
        Returnreason: "Rücksendegrund",
        Optional: "Optional",
        SelectReason: "Grund auswählen",
        Additionalnotes: "Zusätzliche Notizen",
        Describeofcustomerexplanation: "Beschreiben Sie den Zustand des zurückgesendeten Artikels, sichtbare Schäden, Erklärung des Kunden...",
        Requiredmustfilledcontinue: "Erforderliche Felder müssen ausgefüllt werden, um fortzufahren",
        Reviewdetailsbeforeconfirming: "Details vor der Bestätigung überprüfen",
        Replacementproductwilldeductedinventoryconfirmation: "Der Ersatzartikel wird bei Bestätigung von Ihrem Bestand abgezogen.",
        Choosereplacementproduct: "Ersatzartikel auswählen",
        Willdeductedfrominventoryconfirm: "Wird bei Bestätigung vom Bestand abgezogen",
        Thesewillattachedothereturnrecord: "Diese Bilder werden dem Rücksendeprotokoll angehängt",
        Replacementitem: "Ersatzartikel",
        Addanotherproduct: "Weiteren Artikel hinzufügen",
        Replacementproductwillbe: "Ersatzartikel wird",
        deducted: "abgezogen",
        fromyourinventoryconfirmation: "von Ihrem Bestand bei Bestätigung.",
        productadjustedusingprice: "Der zurückgesendete Artikel wird wieder eingelagert und der Gewinn mit dem ursprünglichen Verkaufspreis angepasst.",
        Willloggedreturnedonlynotrestocked: "Wird nur als zurückgesendet protokolliert — nicht wieder eingelagert",
        Returnonly: "Nur zurücksenden",
        Imagesofreturnedproduct: "Bilder des zurückgesendeten Artikels",
        Returnedproductwill: "Zurückgesendeter Artikel wird",
        not: "nicht",
        berestockedloggedreturnedonly: "wieder eingelagert — nur als zurückgesendet protokolliert.",
        AddImage: "Bild hinzufügen",
        STOCKIN: "EINLAGERN",
        LOGONLY: "NUR PROTOKOLLIEREN",
        ContinuetoReview: "Zur Überprüfung fortfahren →",
        Confirmreplacement: "Ersetzung bestätigen",
        Confirmreturn: "Rücksendung bestätigen",
        Filldetailsbelowproceed: "Füllen Sie die Details unten aus, um fortzufahren",
        Review: "Überprüfen",
        editdetails: "Details bearbeiten",
        Configurereturndetails: "Rücksendedetails konfigurieren",
        Configurereplacementdetails: "Ersatzdetails konfigurieren",
        SelectSource: "Quelle auswählen",
        Returning: "Rückgabe",
        Replacement: "Ersatz",
        WalkCustomer: "Laufkunde",
        RETURNEDPRODUCT: "ZURÜCKGEGEBENER ARTIKEL",
        REPLACEMENTPRODUCT: "ERSATZARTIKEL",
        STOCKOUT: "AUSLAGERUNG",
        Netinventoryimpact: "Netto-Bestandsauswirkung",
        Replacementitemcost: "Kosten des Ersatzartikels",
        Returneditemrestockvalue: "Wert der Wiedereinlagerung des zurückgegebenen Artikels",
        PROFITINVENTORYSUMMARY: "GEWINN- & BESTANDSZUSAMMENFASSUNG",
        Inventoryaction: "Bestandsaktion",
        Valuededucted: "Abgezogener Wert",
        Profitadjustment: "Gewinnanpassung",
        stockedout: " ausgelagert",
        restocked: " wieder eingelagert",
        Noaction: "Keine Aktion",
        Valuebeingreturned: "Zurückgegebener Wert",
        Willberestocked: "Wird wieder eingelagert",
        Willbe: "Wird",
        logged: "protokolliert",
        ON: "AN",
        OFF: "AUS",
        Linked: "Verknüpft",
        Pleaseselectreturnedproduct: "Bitte wählen Sie ein zurückgegebenes Produkt aus",
        Quantityrequired: "Menge ist erforderlich",
        Buyingpricerequired: "Einkaufspreis ist erforderlich",
        Pleaseaddleastreplacementproduct: "Bitte fügen Sie mindestens ein Ersatzprodukt hinzu",
        Pleaseconfigurereturnedproductdetails: "Bitte konfigurieren Sie die Details des zurückgegebenen Produkts",
        Pleaseselectcustomer: "Bitte wählen Sie einen Kunden aus",
        Returndateisrequired: "Rückgabedatum ist erforderlich",
        Pleasefillallrequiredfields: "Bitte füllen Sie alle erforderlichen Felder aus",
        Wildeductedfrominventory: "Wird vom Lagerbestand abgezogen",
        Currentprice: "Aktueller Preis",
        Defectivedamaged: "Defekt / beschädigt",
        Wrongitemreceived: "Falscher Artikel erhalten",
        Customerchangedmind: "Kunde hat seine Meinung geändert",
        Sizefitissue: "Größen- / Passformproblem",
        Notasdescribed: "Nicht wie beschrieben",
        Other: "Sonstiges",
        Originalsaleprice: "Originalverkaufspreis (Gewinn angepasst)",
        Addedbackinventory: "Wieder zum Inventar hinzugefügt",
        Notaddedinventory: "Nicht zum Inventar hinzugefügt",
        replacedwith: "ersetzt durch",
        deductedfrominventory: "vom Inventar abgezogen",
        RETURNWITHSTOCKIN: "RÜCKGABE · MIT BESTANDSEINGANG",
        RETURNNOSTOCKIN: "RÜCKGABE · OHNE BESTANDSEINGANG",
        MULTIPLEREPLACEMENTS: "MEHRFACHE ERSATZTEILE",
        SINGLEREPLACEMENT: "EINZELERSATZ",
        InternalTrackingRecordInfo: "This is a record for internal tracking. This process DOES NOT automatically update or delete related invoices, orders, or accounts.",
        ManualStepsIfNeeded: "Manual Steps (if needed):",
        ManualStep1: "Return/Delete invoice from Sale History",
        ManualStep2: "Adjust customer ledger manually",
        ManualStep3: "Update related purchase record",
        RETURNEDSTOCKIN: "ZURÜCKGEGEBEN · BESTAND IN",
        REPLACEMENTSTOCKOUT: "ERSATZ · BESTAND AUS",
        Returnonlylogsthisentry: "Rücksendung protokolliert nur diesen Eintrag —",
        nostockwillbeaddedorremoved: "es wird kein Bestand hinzugefügt oder entfernt",
        frominventory: "vom Lagerbestand.",
        Whentousethis: "Wann Sie dies verwenden sollten:",
        UseReturnenddayrecorditemsoutsalesthatcamebackunusablewantinventory: "Verwenden Sie Rücksendung am Ende des Tages, um Artikel aufzuzeichnen, die für Verkäufe versendet wurden und beschädigt oder unbrauchbar zurückkamen — Artikel, die Sie verfolgen möchten, aber nicht wieder dem Lagerbestand hinzufügen können.",
        Youcanviewallpastreturnentriesin: "Sie können alle vergangenen Rücksendeeinträge einsehen in",
        ReturnHistory: "Rücksendeverlauf",
        underthe: "unter dem",
        Others: "Andere",
        tab: "Tab.",
        Negativestocktransactiondisabled: "Negative Aktientransaktionen sind deaktiviert."
    },
    NewRLocal: {
        Originalsaleprice: "Ursprünglicher Verkaufspreis",
        Editinghistoryonlyinventorystaysunchanged: "Nur Historie bearbeiten — der Bestand bleibt unverändert.",
        Changeshereupdatethisdetailsquantitiesaffected: "Änderungen hier aktualisieren nur die Details dieses Datensatzes (Grund, Datum, Notizen). Ihre tatsächlichen Bestandsmengen, Lagerplätze und Produktdaten sind nicht betroffen.",
        Needtofixinventorylevelsinstead: "Müssen stattdessen die Lagerbestände korrigiert werden?",
        AdjustStock: "Bestand anpassen",
        Refund: "Rückerstattung",
        ImportantNote: "Wichtiger Hinweis",
        Pleasereviewbeforecontinuing: "Bitte vor dem Fortfahren überprüfen",
        Onceshippedreceivedanyupdatesmadeorder: "Sobald eine Bestellung versandt oder empfangen wurde, spiegeln sich Aktualisierungen an der Bestellung nicht in der Transaktionshistorie wider.",
        Thisundone: "Dies wird die Bestellung dauerhaft entfernen. Diese Aktion kann nicht rückgängig gemacht werden.",
        Inventorywilladjustedautomatically: "Der Bestand wird nicht automatisch angepasst",
        Deletingthisreversevedshippedyouwillneed: "Das Löschen dieser Bestellung macht keine Bestandsänderungen rückgängig. Wenn Artikel bereits empfangen/versandt wurden, müssen Sie",
        reflectthecorrectstocklevels: "um die korrekten Lagerbestände widerzuspiegeln.",
        manuallyadjustyourinventory: "Ihren Bestand manuell anpassen",
        Addremovestockforitemsthatwereshipped: "Bestand für versandte Artikel hinzufügen oder entfernen",
        Addremovestockforitemsthatwerereceived: "Bestand für empfangene Artikel hinzufügen oder entfernen",
        Updatecostrecordspaymentwaalreadymade: "Kostenaufzeichnungen aktualisieren, wenn die Zahlung bereits erfolgt ist",
        Reconcilerecordsandoutstandingpayments: "Datensätze und ausstehende Zahlungen abgleichen"
    },
    ReceivablesLocal: {
        Receivables: "Forderungen",
        Manageandtrackcustomerduebalances: "Kundenfällige Salden verwalten und verfolgen",
        Viewcustomerduebalancereport: "Kundenfällige Salden Bericht ansehen",
        Viewsupplierduebalancereport: "Lieferantenfällige Salden Bericht ansehen",
        DueBalance: "Fälliger Saldo",
        Unpaid: "Unbezahlt",
        PartiallyPaid: "Teilweise bezahlt",
        Paid: "Bezahlt",
        HighestBalance: "Höchster Saldo",
        LowestBalance: "Niedrigster Saldo",
        Filldetailsrecordpayment: "Details ausfüllen um Zahlung zu erfassen",
        NewPaymentEntry: "Neuer Zahlungseintrag",
        EditPaymentEntry: "Zahlungseintrag bearbeiten",
        Nosuppliersfound: "Keine Lieferanten gefunden",
        Nocustomersfound: "Keine Kunden gefunden",
        LowtoHigh: "Niedrig zu Hoch",
        HightoLow: "Hoch zu Niedrig",
        AttachmentUploadedSc: "Anhang erfolgreich hochgeladen",
        AttachmentUploadedF: "Anhang konnte nicht hochgeladen werden",
        Pay: "Bezahlen",
        NoBillsFound: "Keine Rechnungen gefunden",
        Thiscustomerhasunpaidbills: "Dieser Kunde hat keine offenen Rechnungen.",
        TotalDue: "Gesamtbetrag fällig",
        BillsFound: "Rechnungen gefunden",
        DeselectAll: "Alle abwählen",
        SelectAll: "Alle auswählen",
        ShowDetails: "Details anzeigen"
    },
    AssetsNewLocal: {
        Assignedon: "Zugewiesen am",
        Total: "Gesamt",
        Assigned: "Zugewiesen",
        Remaining: "Verbleibend",
        Available: "Verfügbar",
        NoSerialNumbers: "Keine Seriennummern",
        UpdateExistingAssetDetails: "Details des vorhandenen Vermögenswerts aktualisieren",
        RegisterNewBusinessAsset: "Neuen Geschäftswert registrieren",
        BasicInformation: "Basisinformationen",
        AssetDetails: "Details zum Vermögenswert",
        Quantity: "Menge",
        SerialNumbers: "Seriennummern",
        SerialNumberPlaceholder: "Seriennummer",
        AddSerialNumber: "Seriennummer hinzufügen",
        SerialNumbersOptional: "Seriennummern sind optional. Sie können bis zu hinzufügen",
        AssetImages: "Bilder des Vermögenswerts",
        AdditionalNotes: "Zusätzliche Hinweise",
        AdditionalNotesPlaceholder: "Zusätzliche Details oder Wartungsverlauf...",
        Updating: "Aktualisieren...",
        Adding: "Hinzufügen...",
        ITEquipmentPlaceholder: "z. B. IT-Ausrüstung",
        LoadingMoreActivities: "Weitere Aktivitäten laden...",
        AssignedAssets: "Zugewiesene Anlagen",
        Noassetsassignedstaffmember: "Keine Anlagen diesem Mitarbeiter zugewiesen.",
        Assignassetstaff: "Anlage einem Mitarbeiter zuweisen",
        Returnassetfromstaff: "Diese Anlage vom Mitarbeiter zurücknehmen",
        AssignmentDetails: "Zuweisungsdetails",
        Serial: "Seriennummer",
        ViewAssets: "Alle Anlagen ansehen",
        ViewByStaff: "Nach Mitarbeiter ansehen",
        AssignedHistory: "Zuweisungshistorie",
        Returned: "Zurückgegeben",
        Returnedon: "Zurückgegeben am",
        ReturnedBy: "Zurückgegeben von",
        AssignedTo: "Zugewiesen an",
        NoHistoryRecords: "Keine Historieeinträge",
        Selectstaffmemberviewtheirassets: "Wählen Sie einen Mitarbeiter aus, um seine Anlagen zu sehen",
        Deleted: "GELÖSCHT",
        searchPlaceholder: "Anlage nach Name oder Seriennummer suchen..."
    },
    InventoryCountLocale: {
        InventoryCount: "Bestandsaufnahme",
        Viewinventorycountreport: "Bestandsaufnahme-Bericht ansehen",
        ItemsCount: "Artikelanzahl",
        All: "Alle",
        InProgress: "In Bearbeitung",
        Submitted: "Eingereicht",
        awaitingreview: "Wartet auf Überprüfung",
        EditInventoryCount: "Bestandsaufnahme bearbeiten",
        NewInventoryCount: "Neue Bestandsaufnahme",
        Modifyinventorycountsheetdetails: "Details des Bestandsblatts bearbeiten",
        Startanewinventorycountsheet: "Neues Bestandsblatt starten",
        GeneralInformation: "Allgemeine Informationen",
        Title: "Titel",
        SaveChanges: "Änderungen speichern",
        Selectproductsforthisinventorycountsheet: "Produkte für dieses Bestandsblatt auswählen",
        InventoryCountDetails: "Details der Bestandsaufnahme",
        Inventorycountsheetdetails: "Details des Bestandsblatts",
        Viewingdetailsforcountsheet: "Details des Zählblatts ansehen",
        Started: "Gestartet",
        TaskSheets: "Aufgabenblätter",
        Allitems: "Alle Artikel",
        NotStarted: "Nicht gestartet",
        Completed: "Abgeschlossen",
        Results: "Ergebnisse",
        ViewResults: "Ergebnisse ansehen",
        DeleteInventoryCount: "Bestandsaufnahme löschen",
        Viewingtransactionandadjustments: "Transaktionsprotokolle und Bestandsanpassungen ansehen",
        Productsadjusted: "Angepasste Produkte",
        Assignee: "Zugewiesen an",
        Tasksheetdetails: "Aufgabenblatt-Details",
        Draft: "Entwurf",
        VariantQuantities: "Variantenmengen",
        AssignedProducts: "Zugewiesene Produkte",
        ReturnAsset: "Anlage zurückgeben",
        EditTasksheet: "Aufgabenblatt bearbeiten",
        NewTasksheet: "Neues Aufgabenblatt",
        Updatetasksheetdetails: "Aufgabenblatt-Details aktualisieren",
        Starttasksheetforthisinventorycount: "Neues Aufgabenblatt für diese Bestandsaufnahme starten",
        TaskSheetInformation: "Aufgabenblatt-Informationen",
        SheetTitle: "Blatt-Titel",
        Entersheettitle: "Blatt-Titel eingeben",
        SubmissionResult: "Einreichungsergebnis",
        ReviewChanges: "Änderungen prüfen",
        Viewingsubmissionresultsforthisinventorycount: "Einreichungsergebnisse dieser Bestandsaufnahme ansehen",
        Reviewyourinventorycountbeforesubmitting: "Überprüfen Sie Ihre Bestandsaufnahme vor dem Einreichen"
    },
    NewMissingLocale: {
        Failedtoloadcounts: "Laden der Zählungen fehlgeschlagen",
        NoInventoryCounts: "Keine Bestandsaufnahmen",
        NoMatches: "Keine Übereinstimmungen",
        Therearenoinventorycountswiththestatus: "Es gibt keine Bestandsaufnahmen mit dem Status",
        Noinventorycountsfoundyoursearchterm: "Keine Bestandsaufnahmen gefunden, die zu Ihrem Suchbegriff passen",
        Thereareinventorycountsrecordedyetforthisbusiness: "Es wurden noch keine Bestandsaufnahmen für dieses Unternehmen aufgezeichnet"
    },
    StockinModalP: {
        StockInNow: "Jetzt Bestand einbuchen",
        Settheopeningquantityforthisproductrightnow: "Legen Sie jetzt die Anfangsmenge für dieses Produkt fest.",
        Addinitialstock: "Anfangsbestand hinzufügen?",
        dothislater: "Ich mache das später",
        Productadded: "Produkt hinzugefügt!",
        isready: "ist bereit.",
        SeeHowItWorks: "So funktioniert es",
        NoSalesOrdersFound: "Keine Verkaufsaufträge gefunden",
        NoPurchaseOrdersFound: "Keine Bestellungen gefunden",
        Startcreatingoutgoinginventoryrevenue: "Erstellen Sie Verkaufsaufträge, um Ihren ausgehenden Bestand und Umsatz zu verfolgen.",
        Trackrestockssupplierplace: "Verfolgen Sie Ihre Bestandsnachbestellungen und Lieferantenbestellungen an einem Ort.",
        CreateSalesOrder: "Verkaufsauftrag erstellen",
        CreatePurchaseOrder: "Bestellung erstellen",
    }
    ,
    dialy_report: "Täglicher Bewegungsbericht",
    Quotation: "Angebot",
    Quote: "Angebot",
    Assignee: "Zugewiesen an",
    dayStart: "Tagesbeginn",

    ShowTotalAmount: "Gesamtbetrag",


    tutorial: {
        watchTitle: 'Sehen Sie sich Schritt-für-Schritt-Anleitungen an',
        watchDesc: 'Lernen Sie SimplyStock auf unserem YouTube-Kanal kennen',
        modalTitle: 'Bleiben Sie mit SimplyStock an der Spitze',
        modalDesc: 'Melden Sie sich an, um neue Tutorials zu erhalten, sobald sie veröffentlicht werden',
        feature1Title: 'Komplettlösungen für neue Funktionen',
        feature1Sub: 'Jedes neue Update mit einem kurzen Video erklärt — damit Sie nie verpassen, was neu ist',
        feature2Title: 'Schnelle Anleitungsvideos',
        feature2Sub: 'Richten Sie Bestände, Rechnungen, Mitarbeiterzugriff und mehr in weniger als 5 Minuten ein',
        feature3Title: 'Sofortige Benachrichtigung',
        feature3Sub: 'Lassen Sie sich benachrichtigen, sobald ein neues Tutorial online ist — lernen Sie in Ihrem eigenen Tempo',
        feature4Title: '100% kostenlos, immer',
        feature4Sub: 'Alle Tutorials sind für immer kostenlos — kein Login oder Abonnement erforderlich',
        subscribeBtn: 'SimplyStock abonnieren',
        maybeLater: 'Vielleicht später'
    }
    ,
    dailyCashReport: {
        "title": "Täglicher Kassenbericht",
        "subtitle": "Wer was gezahlt hat, an welchem Datum, und was noch aussteht — gruppiert aus den Verkaufsdetails.",
        "totalSales": "Gesamtumsatz",
        "cashReceived": "Insgesamt erhalten",
        "outstanding": "Ausstehend",
        "collectionRate": "Einziehungsquote",
        "grandTotalAllDates": "GESAMTSUMME (alle Daten)",
        "totalLabel": "Gesamt",
        "loading": "Laden...",
        "noData": "Keine Daten für den ausgewählten Zeitraum gefunden.",
        "loadingMore": "Mehr laden..."
    },
    dailyCashReportColumns: {
        "date": "Datum",
        "customer": "Kunde",
        "productsSold": "Verkaufte Produkte",
        "products": "Produkte",
        "salesAmount": "Verkaufsbetrag",
        "sales": "Verkauf",
        "received": "Insgesamt erhalten",
        "receivedShort": "Erhalten",
        "debited": "Dem Hauptbuch belastet",
        "due": "Fällig",
        "paymentModes": "Zahlungsart(en)",
        "mode": "Art"
    }
}


export default de
